import React, { useEffect, useState, useRef } from "react";
import classes from "./NewPaymentPage.module.css";
import HeaderNav from '../../Accoungting/HeaderNav/HeaderNav';
import Footer from "../../Accoungting/Footer/Footer";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import { Pen, Trash2, Printer, Eye, RotateCcw } from "lucide-react";
import axios from "axios";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { BASE_URL } from '../../../Components/Styles/API/API';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Tab, Container, Tabs, Row, Col, Popover, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from "react-select";
import { FcPrint } from "react-icons/fc";
import DeleteIcon from "../../../Assets/new-delete.svg"
import { FaTrash, FaPlus } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";
import PaymentsUploadModal from "../../Accoungting/HeaderNav/Journal/PaymentsUploadModal";
import upload from "../../../Assets/upload.svg"
import { BsEyeSlashFill } from "react-icons/bs";
import { jsPDF } from "jspdf";    // <-- correct import for v3
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";







const PaymentBulk = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [accName, setAccName] = useState('');
  const [show, setShow] = useState(false);
  const [phone, setPhone] = useState();
  const [fullName, setFullName] = useState("");
  const [selectedLoanAccounts, setSelectedLoanAccounts] = useState(null); 
  const [journalReference, setJournalReference] = useState('');
 const [banks, setBanks] = useState([]);
  const handleBankChanges = (selectedOption) => {
  setSelectedBank(selectedOption);
};
const [rowses, setRowses] = useState([{ bankName: "", accName: "", accNo: "" }]);

 const handleBeneficiaryChanges = (index, selectedOption) => {

    const updated = [...rows];
  
    updated[index].beneficiaryId = selectedOption?.value || "";
    updated[index].supplierName = selectedOption?.supplierName || "";   // ⭐ NEW: store supplier name
  
    if (selectedOption) {
      // find the beneficiary entry in API data
      const beneficiary = beneficiaryDatas.find(
        b => b.id === selectedOption.value
      );
  
      updated[index].outstandingAmount = beneficiary?.balance || 0;
  
      // Map account options
      updated[index].accountOptions =
        beneficiary?.supplier?.banks?.map(acc => ({
          label: `${acc.bank_name} - ${acc.bank_account}`,
          value: acc.id,
          accountName: acc.account_name,
          bankName: acc.bank_name,
          accountNo: acc.bank_account,
        })) || [];
  updated[index].documentUrl = beneficiary?.attached_document || null;
    } else {
      updated[index].outstandingAmount = "";
      updated[index].accountOptions = [];
      updated[index].supplierName = "";   // clear supplier name
      updated[index].documentUrl = "";   // clear supplier name
    }
  
    setRows(updated);
  };

const handleDescriptionChange = (index, value) => {
  setRows(prev => {
    const updated = [...prev];
    updated[index].description = value;
    return updated;
  });
};
  const addRow = () =>
    setRowses([...rowses, { bankName: "", accName: "", accNo: "" }]);
   const deleteRow = (index) => {
    const updatedRows = rowses.filter((_, i) => i !== index);
    setRowses(updatedRows);
  };
const handleClose = () => setShow(false);
 const handleLoanChanges = (option) => {
  setSelectedLoanAccounts(option);

  // 🟢 Auto-assign debitAccount to ALL rows or last row (choose what you want)
  setRows(prev =>
    prev.map(r => ({
      ...r,
      debitAccount: option.value   // store the loan account ID
    }))
  );
};

const [showViewModal, setShowViewModal] = useState(false);
const [viewPaymentData, setViewPaymentData] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [showRev, setShowRev] = useState(false);
  const handleCloseRev = () => setShowRev(false);
  const [showEdit, setShowEdit] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => setShow2(true);
  const handleShowEdit = () => setShowEdit(true);
  // const handleShowRev = () => setShowRev(true);
  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);
  const handleCloseEdit = () => setShowEdit(false);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [description, setDescription] = useState("");
  const [refno, setRefNo] = useState("");
  const [amount, setAmount] = useState("");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [bankOptions2, setBankOptions2] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  // const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedBank2, setSelectedBank2] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
  const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalEntries, setTotalEntries] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [currLoading, setCurrLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [user, setUser] = useState('');
  const [loanBen,  setLoanBen] = useState([]);
  const [loanAccountOptions, setLoanAccountOptions] = useState([]);
  const [paymentType, setPaymentType] = useState('');
  const [paymentTo, setPaymentTo] = useState(null);
  const [date, setDate] = useState('');
  const [currency1, setCurrency1] = useState(null);
  const [description1, setDescription1] = useState('');
  const [modeOfPayment, setModeOfPayment] = useState('');
  const [debitAccount, setDebitAccount] = useState(null);
  const [totalAmount, setTotalAmount] = useState('');
  const [loanAccount, setLoanAccount] = useState(null);
  const [reference, setReference] = useState('');
  const [payOptions, setPayOptions] = useState([]);
  const [mopOptions, setmopOptions] = useState([]);
  const [showPay, setShowPay] = useState(false);
  const [showRetrievePay, setShowRetrievePay] = useState(false);
  const [showRetrievePaySaved, setShowRetrievePaySaved] = useState(false);
    const [beneficiaryDatas, setBeneficiaryDatas] = useState([]);
  const [isSaved,setisSaved] =  useState(false);
  const handleClosePay = () => {
      setViewData([]); 
    setShowPay(false);
    fetchReference();
    setSelectedPaymentType('');
    setRows([{ 
        beneficiaryId: "", 
        outstandingAmount: "", 
        accountId: "", 
        amountToPay: "" ,
        description: "" ,
         accountOptions: [],
      }]);
  };
  const handleCloseRetrievePay = () => {
  setViewData([]);  
    setShowRetrievePay(false);
    setSelectedPaymentType('');
    setJournalReference('');
    fetchReference();
    setRows([{ 
        beneficiaryId: "", 
        outstandingAmount: "", 
        accountId: "", 
        amountToPay: "" ,
        description: "",
         accountOptions: [],
      }]);
  };
  const handleCloseRetrievePaySaved = () => {
  setViewData([]);  
    setShowRetrievePaySaved(false);
    setSelectedPaymentType('');
    setRows([{ 
        beneficiaryId: "", 
        outstandingAmount: "", 
        accountId: "", 
        amountToPay: "" ,
        description: "",
         accountOptions: [],
      }]);
  };
  const [showReferenceModal, setShowReferenceModal] = useState(false);
const [referenceOptions, setReferenceOptions] = useState([]);
const [loadingReferences, setLoadingReferences] = useState(false);
  // const handleShowPay = () => setShowPay(false);
  const handleShowPay = () => setShowPay(true);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [error, setError] = useState(null);
  const [showBeneficiaryAccModal, setShowBeneficiaryAccModal] = useState(false);
const [currentBeneficiaryId, setCurrentBeneficiaryId] = useState(null);
  const [accountName, setAccountName] = useState("");
  const [accountNameId, setAccountNameId] = useState("");
  const [accountCode, setAccountCode] = useState("");
  const [journalls, setJournalls] = useState([]);
  const [selectedUUID, setSelectedUUID] = useState(null);
  const [loadingRef, setLoadingRef] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [receivables,setReceivables] = useState([])
const [statutory,setStatutory] = useState([])
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isSaving1, setIsSaving1] = useState(false);
  // const [description, setDescription] = useState("");
  // const [debitAccount, setDebitAccount] = useState("");
  // const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  // const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  // const [loanOptions, setLoanOptions] = useState([]); // new state for loan options
  const [employeeOptions, setEmployeeOptions] = useState([]); // new state for employee options
  const [supplierOptions, setSupplierOptions] = useState([]); // new state for supplier options
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [extraRows, setExtraRows] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [paymentToLoading, setPaymentToLoading] = useState(false); // <-- ADD THIS LINE
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  // const [totalAmount, setTotalAmount] = useState("");
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);

  const [expenseOptions, setExpenseOptions] = useState([]);
  // const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [receiptType, setReceiptType] = useState("");
  // const [selectedCurrency, setSelectedCurrency] = useState("");
  // const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);
  const [payLoad, setPayLoad] = useState(false);

    const [selectOptions, setSelectOptions] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [suppliers, setSuppliers] = useState([]);
  const [debit1, setDebit1] = useState([]);
  const [debit2, setDebit2] = useState([]);
   const [bankName, setBankName] = useState('');
    const [accNo, setAccNo] = useState('');
    const [address, setAddress] = useState([]);
  const payment = location.state?.payment;
    const [openJournalModal, setOpenJournalModal] = useState(false);
   const [maxDate, setMaxDate] = useState("");
        const [minDate, setMinDate] = useState("");
        const [reverseLoading, setReverseLoading] = useState(false);
        const [reverseLoading2, setReverseLoading2] = useState(false);
        const [startDate, setStartDate] = useState("");
        const [endDate, setEndDate] = useState("");
        const [showDown, setShowDown] = useState(false);
        const handleShowDown = () => setShowDown(true);
        const handleCloseDown = () => {
          setShowDown(false)
          setStartDate("");
          setEndDate("");
          setSelectedPaymentType("");
          setSelectedPayment("");
        };



  
    const readData = async () => {
      try {
        const value = await localStorage.getItem('userToken');
        const value1 = await localStorage.getItem('tobi');
  const current = await localStorage.getItem('currentMonth');
  
        if (value !== null && value.trim() !== '') {
          setBearer(value);
        } else {
          navigate('/login');
          return;
        }

        if (current !== null) {
          console.log(current)
          const date = new Date(current);  // Assume current is in a parsable date format
  
          // setCurrentMonth(date);
          const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
          const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          // Set the min and max date for the date input
  
          const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');  // Add leading zero
            const day = String(date.getDate()).padStart(2, '0');         // Add leading zero
            return `${year}-${month}-${day}`;
        };
          
         setMinDate(formatDate(startOfMonth));
        setMaxDate(formatDate(endOfMonth));
      }
  
        if (value1 !== null) {
          setUser(value1);
        }
  
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };
  
    useEffect(() => {
      readData();
    }, []);


      const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


    const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };


  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const token = localStorage.getItem("authToken");
  //       const res = await axios.get(`${BASE_URL}/v1/payments-made`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         }
  //       );
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       // Optionally handle error
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);

    const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

   const [rows, setRows] = useState([
    {
      beneficiaryId: "",
      debitAccount: "",
      outstandingAmount: "",
      accountId: "",
      amountToPay: "",
      description: "",
      accountOptions: [],   // <-- added
    },
  ]);

  



  


  
  const addLine = async () => {
    if (!selectedPaymentType) {
    Swal.fire("Missing Field", "Please select a payment type.", "warning");
    return;
  }

  if (!journalReference) {
    Swal.fire("Missing Field", "Journal Reference has not been generated yet.", "warning");
    return;
  }

  if (!selectedPayment) {
    Swal.fire("Missing Field", "Please select a mode of payment.", "warning");
    return;
  }

  if (!transactionDate) {
    Swal.fire("Missing Field", "Please select a transaction date.", "warning");
    return;
  }

  if (!selectedBank) {
    Swal.fire("Missing Field", "Please select a bank.", "warning");
    return;
  }


  // 🔥 Extra validation only for Loan Disbursement (Type 3)
  if (selectedPaymentType === "3" && !selectedLoanAccounts) {
    Swal.fire("Missing Field", "Please select a loan type.", "warning");
    return;
  }

  if (rows.length > 0) {
    const last = rows[rows.length - 1];

    if (!last.beneficiaryId) {
      Swal.fire("Missing Field", "Please select a beneficiary in the last row.", "warning");
      return;
    }

    if (!last.accountId) {
      Swal.fire("Missing Field", "Please select a beneficiary account in the last row.", "warning");
      return;
    }

 if (!isPayable && !last?.debitAccount) {
  Swal.fire(
    "Missing Field",
    "Please select a debit account in the last row.",
    "warning"
  );
  return;
}


    if (!last.amountToPay || Number(last.amountToPay) <= 0) {
      Swal.fire("Missing Field", "Amount to pay cannot be empty.", "warning");
      return;
    }
  }


  
     await handleAddLineAPI();
    setRows([
      ...rows,
      { 
        beneficiaryId: "", 
        outstandingAmount: "", 
        accountId: "", 
        amountToPay: "" ,
        description: "",
         accountOptions: [],
      //    paymentType: selectedPaymentType,
      //    loanAccount: null,
      // locked: false,
      }
    ]);
  };
  const addLines = async () => {
      if (!selectedPaymentType) {
    Swal.fire("Missing Field", "Please select a payment type.", "warning");
    return;
  }

  if (!journalReference) {
    Swal.fire("Missing Field", "Journal Reference has not been generated yet.", "warning");
    return;
  }

  if (!selectedPayment) {
    Swal.fire("Missing Field", "Please select a mode of payment.", "warning");
    return;
  }

  if (!transactionDate) {
    Swal.fire("Missing Field", "Please select a transaction date.", "warning");
    return;
  }

  if (!selectedBank) {
    Swal.fire("Missing Field", "Please select a bank.", "warning");
    return;
  }


  // 🔥 Extra validation only for Loan Disbursement (Type 3)
  if (selectedPaymentType === "3" && !selectedLoanAccounts) {
    Swal.fire("Missing Field", "Please select a loan type.", "warning");
    return;
  }

  if (rows.length > 0) {
    const last = rows[rows.length - 1];

    if (!last.beneficiaryId) {
      Swal.fire("Missing Field", "Please select a beneficiary in the last row.", "warning");
      return;
    }

    if (!last.accountId) {
      Swal.fire("Missing Field", "Please select a beneficiary account in the last row.", "warning");
      return;
    }

     if (!isPayable && !last?.debitAccount) {
  Swal.fire(
    "Missing Field",
    "Please select a debit account in the last row.",
    "warning"
  );
  return;
}

    if (!last.amountToPay || Number(last.amountToPay) <= 0) {
      Swal.fire("Missing Field", "Amount to pay cannot be empty.", "warning");
      return;
    }
  }
     await handleAddLineAPIs();
    setRows([
      ...rows,
      { 
        beneficiaryId: "", 
        outstandingAmount: "", 
        accountId: "", 
        amountToPay: "" ,
         accountOptions: [],
         description: "",
      //    paymentType: selectedPaymentType,
      //    loanAccount: null,
      // locked: false,
      }
    ]);
  };
    const addLinesSaved = async () => {
      if (!selectedPaymentType) {
    Swal.fire("Missing Field", "Please select a payment type.", "warning");
    return;
  }

  if (!journalReference) {
    Swal.fire("Missing Field", "Journal Reference has not been generated yet.", "warning");
    return;
  }

  if (!selectedPayment) {
    Swal.fire("Missing Field", "Please select a mode of payment.", "warning");
    return;
  }

  if (!transactionDate) {
    Swal.fire("Missing Field", "Please select a transaction date.", "warning");
    return;
  }

  if (!selectedBank) {
    Swal.fire("Missing Field", "Please select a bank.", "warning");
    return;
  }


  // 🔥 Extra validation only for Loan Disbursement (Type 3)
  if (selectedPaymentType === "3" && !selectedLoanAccounts) {
    Swal.fire("Missing Field", "Please select a loan type.", "warning");
    return;
  }

  if (rows.length > 0) {
    const last = rows[rows.length - 1];

    if (!last.beneficiaryId) {
      Swal.fire("Missing Field", "Please select a beneficiary in the last row.", "warning");
      return;
    }

    if (!last.accountId) {
      Swal.fire("Missing Field", "Please select a beneficiary account in the last row.", "warning");
      return;
    }

    if (!isPayable && !last?.debitAccount) {
  Swal.fire(
    "Missing Field",
    "Please select a debit account in the last row.",
    "warning"
  );
  return;
}

    if (!last.amountToPay || Number(last.amountToPay) <= 0) {
      Swal.fire("Missing Field", "Amount to pay cannot be empty.", "warning");
      return;
    }
  }
     await handleAddLineAPIsSaved();
    setRows([
      ...rows,
      { 
        beneficiaryId: "", 
        outstandingAmount: "", 
        accountId: "", 
        amountToPay: "" ,
         accountOptions: [],
         description: "",
      //    paymentType: selectedPaymentType,
      //    loanAccount: null,
      // locked: false,
      }
    ]);
  };
  

  
  
  
  
  const [beneficiaryData, setBeneficiaryData] = useState([]);
  const [loanData, setLoanData] = useState([]);
  const [expensesData, setExpensesData] = useState([]);
  const [showDocModal, setShowDocModal] = useState(false);
  const [currentDocUrl, setCurrentDocUrl] = useState(null);
  const [beneficiaryOptions, setBeneficiaryOptions] = useState([]);

  const handleOpenDoc = (docUrl) => {
    setCurrentDocUrl(docUrl);
    setShowDocModal(true);
  };
  
  const handleCloseDoc = () => {
    setCurrentDocUrl(null);
    setShowDocModal(false);
  };
  
 const fetchPayables = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/beneficiary`, 
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      }
    );
    const data = response.data?.data || [];
    setBeneficiaryData(data);
    
    // 🔥 ALSO UPDATE OPTIONS IF NO SPECIAL PAYMENT TYPE SELECTED
    if (!selectedPaymentType || (selectedPaymentType !== "3" && selectedPaymentType !== "5")) {
      setBeneficiaryOptions(
        data.map(b => ({
          label: b.name,
          value: b.id,
          supplierName: b.name,
          balance: b?.balance,
        }))
      );
    }
  } catch (err) {
    console.error(err);
  }
};

const fetchPayablesAndReturn = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/beneficiary`, 
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      }
    );
    const data = response.data?.data || [];
    setBeneficiaryData(data); // Update state
    return data; // Return data for immediate use
  } catch (err) {
    console.error(err);
    return [];
  }
};

  const fetchExpensesAccount = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/account/expenses`, 
        {
                           headers: {
                             'Content-Type': 'application/json',
                             'Authorization': `Bearer ${bearer}`
                           }
                         }
      );
      setExpensesData(response.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };
  const fetchLoan = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/account/fetch-loans`, 
        {
                           headers: {
                             'Content-Type': 'application/json',
                             'Authorization': `Bearer ${bearer}`
                           }
                         }
      );
      setLoanData(response.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };
  
   const fetchReference = async () => {
        setLoadingRef(true);
        try {
          const res = await axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
            headers: {
              Authorization: `Bearer ${bearer}`,
              Accept: "application/json",
            },
          });
         setJournalReference(res.data.data);
        } catch (error) {
          console.error("Error fetching journal reference:", error);
        } finally {
          setLoadingRef(false);
        }
      };
  
  useEffect(() => {
    if (bearer)
    fetchPayables();
    fetchReference();
    fetchExpensesAccount();
    fetchLoan();
  }, [bearer]);

  const loadPaymentReferences = async () => {
  setLoadingReferences(true);
  try {
    const res = await axios.get(`${BASE_URL}/fetch-processed-beneficiary-payments`, { headers });

    const formatted = res.data.data.map(item => ({
      label: `${item.receipt_number} - ${item.particular || item.customer?.name || "Unknown"} - ${Number(item.total_amount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      value: item.id,
      raw: item // store full item if needed later
    }));

    setReferenceOptions(formatted);

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Failed to load references",
      text: err?.response?.data?.message || "Something went wrong."
    });
  } finally {
    setLoadingReferences(false);
  }
};
const [selectedReference, setSelectedReference] = useState(null);

const openReferenceModal = () => {
  setShowReferenceModal(true);
  loadPaymentReferences();
};



  
const loadBeneficiaryData = async () => {
  let endpoint = "";

  if (selectedPaymentType === "3") {
    endpoint = "/customer/loan-customers-select";
  } 
  else if (selectedPaymentType === "5") {
    endpoint = "/customer/advance_customers_select";
  } 
  
  if (endpoint) {
    // Special endpoints for loan/advance customers
    try {
      const res = await axios.get(`${BASE_URL}${endpoint}`, { headers });
      const formatted = res.data.data.map(item => ({
        label: `${item.name} - ${item.employee_no ?? 'Nil'}`,
        value: item.id,
        supplierName: item.name,
        image: item?.attached_document,
        balance: item?.balance,
        banks: item?.banks || [],
        id: item?.id,
      }));
      setBeneficiaryOptions(formatted);
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error loading beneficiaries",
        text: err?.response?.data?.message || "Please try again."
      });
    }
  } else {
    // General beneficiaries - always refresh from beneficiaryData
    setBeneficiaryOptions(
      beneficiaryData.map(b => ({
        label: b.name,
        value: b.id,
        supplierName: b.name,
        balance: b?.balance,
      }))
    );
  }
};
useEffect(() => {
  if (selectedPaymentType) {
    loadBeneficiaryData();
  }
}, [selectedPaymentType]);


const fetchPayabless = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/fetch_beneficiary_payables`, 
        {
                           headers: {
                             'Content-Type': 'application/json',
                             'Authorization': `Bearer ${bearer}`
                           }
                         }
      );
      setBeneficiaryDatas(response.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };
  
    useEffect(() => {
      if (bearer)
      fetchPayabless();
      // fetchReference();
    }, [bearer]);
    
  // const beneficiaryOptions = beneficiaryData.map(item => ({
  //   label: item.name,
  //   value: item.id,
  //   supplierName: item.supplier?.name,
  //   image: item?.attached_document
  // }));

    const beneficiaryOptionss = beneficiaryDatas.map(item => ({
    label: `${item.invoice_number} - ${item.supplier?.name}`,
    value: item.id,
    supplierName: item.supplier?.name,
    image: item?.attached_document
  }));

  const expensesOptions = expensesData.map(item => ({
    label: `${item.gl_code} - ${item.gl_name}`,
    value: item.id,
    
  }));

  const loanOptions = loanData.map(item => ({
    label: item.description,
    value: item.id,
    accountName: item.report?.gl_name || "",
  }));

  

const handleBeneficiaryChange = (index, selectedOption) => {
  const updated = [...rows];

  updated[index].beneficiaryId = selectedOption?.value || "";
  updated[index].supplierName = selectedOption?.supplierName || "";

  // --- RESET if null ---
  if (!selectedOption) {
    updated[index].outstandingAmount = "";
    updated[index].accountOptions = [];
    updated[index].supplierName = "";
    updated[index].documentUrl = "";
    setRows(updated);
    return;
  }

  // ------------------------------------------
  // 🔥 CONDITION: WHICH SOURCE SHOULD WE USE?
  // selectedPayment === "3" → beneficiaryOptions
  // else → beneficiaryData
  // ------------------------------------------
  
  const sourceArray =
  selectedPaymentType === "3" || selectedPaymentType === "5"
    ? beneficiaryOptions
    : beneficiaryData;

  const beneficiary = sourceArray.find(
    (b) => b.id === selectedOption.value
  );
console.log(beneficiaryOptions, "beneficiary details")
  // BALANCE
  updated[index].outstandingAmount = beneficiary?.balance || 0;

  // BANKS MAPPING – handle BOTH structures
  updated[index].accountOptions =
    beneficiary?.banks?.map((acc) => ({
      label: `${acc.bank_name} - ${acc.account_number || acc.bank_account}`,
      value: acc.id,
      accountName: acc.account_name,
      bankName: acc.bank_name,
      accountNo: acc.account_number || acc.bank_account, // supports both API formats
    })) || [];

  // DOCUMENT
  updated[index].documentUrl = beneficiary?.attached_document || null;

  setRows(updated);
};

 

  const handleExtraBeneficiaryChange = (index, selectedOption) => {
    const updated = [...extraRows];
  
    updated[index].beneficiaryId = selectedOption?.value || "";
    updated[index].supplierName = selectedOption?.supplierName || "";   // ⭐ NEW: store supplier name
  
    if (selectedOption) {
      // find the beneficiary entry in API data
      const beneficiary = beneficiaryData.find(
        b => b.id === selectedOption.value
      );
  
      updated[index].outstandingAmount = beneficiary?.balance || 0;
  
      // Map account options
      updated[index].accountOptions =
        beneficiary?.banks?.map(acc => ({
          label: `${acc.bank_name} - ${acc.bank_account}`,
          value: acc.id,
          accountName: acc.account_name,
          bankName: acc.bank_name,
          accountNo: acc.bank_account,
        })) || [];
  updated[index].documentUrl = beneficiary?.attached_document || null;
    } else {
      updated[index].outstandingAmount = "";
      updated[index].accountOptions = [];
      updated[index].supplierName = "";   // clear supplier name
      updated[index].documentUrl = "";   // clear supplier name
    }
  
    setExtraRows(updated);
  };
  
  
  
  
  const handleAccountChange = (index, selectedOption) => {
    const updatedRows = [...rows];
    updatedRows[index].accountId = selectedOption?.value || "";
    setRows(updatedRows);
  };
  const handleExpensesAccountChange = (index, selectedOption) => {
    const updatedRows = [...rows];
    updatedRows[index].debitAccount = selectedOption?.value || "";
    setRows(updatedRows);
  };
  const handleExtraExpensesAccountChange = (index, selectedOption) => {
    const updatedRows = [...extraRows];
    updatedRows[index].debitAccount = selectedOption?.value || "";
    setExtraRows(updatedRows);
  };
  const handleExtraAccountChange = (index, selectedOption) => {
    const updatedRows = [...extraRows];
    updatedRows[index].accountId = selectedOption?.value || "";
    setExtraRows(updatedRows);
  };
  
  const handleAmountChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].amountToPay = value || "";
    setRows(updatedRows);
    
    // Recalculate total amount
    // const total = updatedRows.reduce((sum, row) => {
    //   const amount = parseFloat(row.amountToPay) || 0;
    //   return sum + amount;
    // }, 0);
    // setTotalAmount(total);
  };

  const handleExtraAmountChange = (index, value) => {
    const updatedRows = [...extraRows];
    updatedRows[index].amountToPay = value || "";
    setExtraRows(updatedRows);
    
    // Recalculate total amount
    const total = updatedRows.reduce((sum, row) => {
      const amount = parseFloat(row.amountToPay) || 0;
      return sum + amount;
    }, 0);
    setTotalAmount(total);
  };

 const handleReferenceChange = (selectedOption) => {
  setLoanAccountOptions([])
  setSelectedLoanAccount("")
  const value = selectedOption ? selectedOption.value : "";
  setReference(value);
};
  // const totalEntries = filteredData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);


    const fetchInvoices = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/payments-made`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setInvoices(res.data.data);
        }
      } catch (err) {
        setInvoices([]);
      } finally {
        setLoading(false);
      }
    };

    // load invoices on mount
    useEffect(() => {
      fetchInvoices();
    }, []);

    const fetchExpenses = async () => {
    setPaymentLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-beneficiary-payments?page=${currentPage}`, { headers });

      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(results, "accounts full");
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    } finally {
      setPaymentLoading(false);
    }
  };

  
         const handleOpenPayModal = () => {
  setShowPay(true);
  fetchPayabless()
  // Reset form when opening
  setSelectedPayment("");
  setTransactionDate("");
  setSelectedBank(null);
  setRows([{ beneficiaryId: "", outstandingAmount: "", accountId: "", amountToPay: "", description: "", }]);
  setTotalAmount(0);
  
  // Fetch fresh data if needed
  
  fetchPayables();
  fetchReference();
  // fetchAccounts();
};


    const fetchCurrency = async () => {
        setCurrLoading(true);
        try {
            const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
            const results = response.data?.data;
            // console.log(results, "currencis")
            const options = results.map((item) => ({
                label: item.name || item.code,
                value: item.id,
                symbol: item.symbol
            }));
            setCurrency(results);
            setCurrencyOptions(options);
        } catch (error) {
            const errorStatus = error.response?.data?.message;
            console.log(errorStatus);
            setCurrency([]);
        } finally {
            setCurrLoading(false);
        }
    };

  useEffect(() => {
    if (bearer) {
      fetchExpenses();
      fetchCurrency();
      //   fetchTotalExpenses();
    }
  }, [bearer, currentPage]);


    useEffect(() => {
      const fetchCurrencies = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/fetch-all-currencies`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name || item.code,
            }))
            : [];
          setCurrencyOptions(options);
        } catch (err) {
          setCurrencyOptions([]);
        }
      };
      fetchCurrencies();
    }, []);

    useEffect(() => {
      const fetchBank = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/get-cash-and-bank`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.gl_name,
            }))
            : [];
          setBankOptions(options);
        } catch (err) {
          setBankOptions([]);
        }
      };
      fetchBank();
    }, []);

    useEffect(() => {
      const fetchBank2 = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/get-cash-and-bank`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.gl_name,
            }))
            : [];
          setBankOptions2(options);
        } catch (err) {
          setBankOptions2([]);
        }
      };
      fetchBank2();
    }, []);

    useEffect(() => {
      const fetchPaymentMode = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/income/get-payment-method`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name,
            }))
            : [];
          setPaymentMode(options);
        } catch (err) {
          setPaymentMode([]);
        }
      };
      fetchPaymentMode();
    }, []);


      useEffect(() => {
        const fetchCustomers = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/beneficiary`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [];
            setCustomerOptions(options);
          } catch (err) {
            setCustomerOptions([]);
          }
        };
        fetchCustomers();
      }, []);

      useEffect(() => {
        const fetchInvoiceOptions = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/fetch-pending-purchases-invoice`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            console.log(res);
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: `${item.invoice_number} - ${item.supplier?.name}`,
                balance: item.balance,
              }))
              : [];
            setInvoiceOptions(options);
          } catch (err) {
            setInvoiceOptions([]);
          }
        };
        fetchInvoiceOptions();
      }, []);
  

  // Skeleton loader rows
  // const SkeletonRows = () => (
  //   <>
  //     {[...Array(5)].map((_, idx) => (
  //       <tr key={idx}>
  //         {Array(10).fill().map((_, i) => (
  //           <td key={i}>
  //             <div className={classes.skeletonLoader}></div>
  //           </td>
  //         ))}
  //       </tr>
  //     ))}
  //   </>
  // );

  // Helper for status
  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };

    // useEffect(() => {
    //   const link = document.createElement("link");
    //   link.rel = "stylesheet";
    //   link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    //   document.head.appendChild(link);
    //   return () => {
    //     document.head.removeChild(link);
    //   };
    // }, []);

    const fetchBanks = async () => {
                 setIsLoading(true);
                 try {
                   const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
                   const results = response.data?.data;
             
                   const options1 = results.map((item) => ({
                     label: item.gl_name,
                     value: item.id,
                     account: item.gl_code
                   }));
                   setBanks(options1);
                   // setSelectOptions(options);
                 } catch (error) {
                   const errorStatus = error.response?.data?.message;
                   console.log(errorStatus);
                   setBanks([]);
                 } finally {
                   setIsLoading(false);
                 }
               };
    
               useEffect(() => {
                       if (bearer) {
                       
                         fetchBanks();
                       
                       }
                     }, [bearer]);

  const addPayment = async () => {
    setAddPaymenntLoad(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/pay-purchase-invoice`, 

        {
          payment_type: selectedRadio,
          transaction_date: paymentDate,
          supplier_id: selectedCustomer?.value,
          supplier: customerName,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

          fetchInvoices();
          handleClose1();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad(false);
    }
  };
const handleAddExtraLine = () => {
  setExtraRows(prev => [
    ...prev,
    {
       beneficiaryId: "",
      debitAccount: "",
      accountId: "",
      amountToPay: "",
      accountOptions: [], 
    }
  ]);
};

const removeExtraRow = (index) => {
  setExtraRows(prev => prev.filter((_, i) => i !== index));
};
  const addPayment2 = async () => {
    setAddPaymenntLoad2(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/pay-supplier-purchase-invoice`, 

        {
          // payment_type: selectedRadio,
          transaction_date: paymentDate,
          id: selectedInvoice?.value,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

          fetchInvoices();
          handleClose2();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad2(false);
    }
  };



//  const handlePrint = (rowData) => {
//   navigate("/invoice-previeww", {
//     state: {
//       invoiceNumber: rowData.invoice_number,
//       invoiceDate: rowData.invoice_date,
//       dueDate: rowData.due_date,
//       customer: {
//         name: rowData.customer_name,
//         phone_number: rowData.customer_phone,
//         email: rowData.customer_email,
//       },
//       items: rowData.items,
//       total: rowData.total,
//     },
//   });
// };


  const handleTrashClick = async (id) => {
  const confirmed = await Swal.fire({
    title: "Are you sure?",
    text: "You are about to delete this payment.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "No, cancel",
  });

  if (!confirmed.isConfirmed) return;

  // Show LOADING modal
  Swal.fire({
    title: "Deleting...",
    text: "Please wait",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    const response = await axios.get(
      `${BASE_URL}/delete-beneficiary-payment?id=${id}`,
      { headers }
    );

    Swal.close(); // stop loader

    // SUCCESS alert
    await Swal.fire({
      imageUrl: verified,
      title: "Success!",
      text: response.data.message,
      confirmButtonText: "Okay",
      imageWidth: 48,
      imageHeight: 48,
      customClass: {
        title: classes.myTitle,
        popup: classes.myText,
        confirmButton: classes.myButton,
      },
      allowOutsideClick: false,
    });

    // 🔥 REMOVE deleted item from the UI immediately
    setViewPaymentData(prev => prev.filter(item => item.id !== id));

    // Optional: refresh list in main table
    fetchExpenses();

  } catch (error) {
    Swal.close();

    let errorMessage = "An error occurred. Please try again.";

    if (error.response?.data?.message) {
      errorMessage =
        typeof error.response.data.message === "string"
          ? error.response.data.message
          : JSON.stringify(error.response.data.message);
    }

    Swal.fire({
      imageUrl: crop,
      imageWidth: 48,
      imageHeight: 48,
      title: "Failed!",
      text: errorMessage,
      confirmButtonText: "Okay",
      customClass: {
        title: classes.myTitle,
        popup: classes.myText,
        confirmButton: classes.myDeclineButton,
      },
      allowOutsideClick: false,
    });
  }
};



// const handlePrint = (id) => {
//   navigate("/print_payments", {
//     state: { invoice: tableData },
//   });
// };

// const handlePrint = (uuid) => {
//   const selectedInvoice = tableData.find((item) => item.uuid === uuid);
//   if (!selectedInvoice) return;

//   // Get the bank name and normalize it
//   const bankName = selectedInvoice.bank_lodged?.gl_name?.toLowerCase() || "";

//   let route = "/print_payments"; // Default route

//   if (bankName.includes("ecobank")) {
//     route = "/print_payments";
//   } else if (bankName.includes("providus")) {
//     route = "/print_providus_payments";
//   // } else if (bankName.includes("uba")) {
//   //   route = "/print_uba_payments";
//   // } else if (bankName.includes("access")) {
//   //   route = "/print_access_payments";
//   } else if (bankName.includes("zenith")) {
//     route = "/print_zenith_payments";
//   }

//   navigate(route, { state: { invoice: selectedInvoice } });
// };



  const fetchCurrency1 = async () => {
    setCurrLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
      const results = response.data?.data;
        // console.log(results, "currencis")
      const options = results.map((item) => ({
        label: item.code,
        value: item.id,
        symbol: item.symbol,
        country: item.country
      }));
      setCurrency(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCurrency([]);
    } finally {
        setCurrLoading(false);
    }
  };
// currency
  useEffect(() => {
    if (bearer) {
        fetchCurrency1();
    }
}, [bearer]);

  const handleCurrencyChange = (selectedOption) => {
    setSelectedCurrency(selectedOption.value);
  };

  const fetchCharts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
      label: `${item.name}${item?.balance != null ? ` - (bal: ${item.balance.toLocaleString()})` : ''}`,
        // bank: item.bank_name,          
        value: item.id,
      }));
      console.log(response , "full reponse");
      setSuppliers(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setSuppliers([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLoanBen = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/loan-customers-select`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: item.name,
        // bank: item.bank_name,
        value: item.id,
      }));
      console.log(response , "loan Benf");
      setLoanBen(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setLoanBen([]);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchCashAdvance = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/advance_customers_select`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: item.name,
        // bank: item.bank_name,
        value: item.id,
      }));
      console.log(response , "loan Benf");
      setLoanBen(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setLoanBen([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLoanAccount = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/fetch_select_loans_new?customer_id=${reference}`, { headers });
       setLoanAccountOptions([])
      const results = response.data?.data;
      const opt1 = results.map((item) => ({
        value: item?.id,
     label: `${item?.description}${item?.customer_balance != null ? ` - (bal: ${item.customer_balance.toLocaleString()})` : ''}`,
        gl_code: item?.report?.gl_code,
        gl_name: item?.report?.gl_name,
        gl_id: item?.report?.id
      }));
      console.log(response , "loan Benf");
      setLoanAccountOptions(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setLoanAccountOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
      fetchLoanAccount();
  },[reference])

  useEffect(() => {
    if (bearer) {
      fetchLoanBen();
      fetchCharts();
    
    }
  }, [bearer]);
  useEffect(() => {
    if (bearer) {
      fetchCashAdvance();
    
    }
  }, [bearer]);




  
  const fetchMode = async () => {
       
    try {
        const response = await axios.get(`${BASE_URL}/income/get-payment-method`, { headers });
        const results = response.data?.data;
        setPaymentModes(results);
    } catch (error) {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
      setPaymentModes([]);
    } finally {
        
    }
};

    useEffect(() => {
      if (bearer) {
        // fetchCurrency();
        fetchMode();
        // fetchDebit1();
        //       fetchDebit2();
        //   fetchTotalExpenses();
      }
    }, [bearer]);

    const [benLoading, setBenLoading] = useState(false);

    const createBeneficiary = async () => {
  setBenLoading(true);
  try {
    const bankAccounts = rowses.map(item => item.accNo);
    const accountNames = rowses.map(item => item.accName);
    const bankNames = rowses.map(item => item.bankName);
    const response = await axios.post(`${BASE_URL}/beneficiary/add_new`,
      {
        name: fullName,
        email: email,
        phone_number: phone,
        address: address,
        bank_name: bankNames,
        account_name: accountNames,
        bank_account: bankAccounts
      },
      { headers }
    );
    
    // RESET FORM
    setFullName('');
    setEmail('');
    setPhone('');
    setAddress('');
    setBankName('');
    setAccName('');
    setAccNo('');
    
    // 🔥 REFRESH BOTH: beneficiaryData AND beneficiaryOptions
    await fetchPayables(); // This updates beneficiaryData
    
    setRowses([{ bankName: "", accName: "", accNo: "" }]);
    handleClose();
    
    // 🔥 FORCE RELOAD BENEFICIARY OPTIONS
    // If a payment type is selected, reload based on that type
    if (selectedPaymentType) {
      await loadBeneficiaryData();
    } else {
      // If no payment type selected (general case), refresh from beneficiaryData
      const updatedBeneficiaries = await fetchPayablesAndReturn();
      setBeneficiaryOptions(
        updatedBeneficiaries.map(b => ({
          label: b.name,
          value: b.id,
          supplierName: b.name,
          balance: b?.balance,
        }))
      );
    }
    
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });

  } catch (error) {
  let errorMessage;
    
          // Attempt to extract the error message
          if (error.response && error.response.data) {
            // If message is an object, attempt to stringify it
            if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            } else {
              errorMessage = error.response.data.message;
            }
          } else if (error.message) {
            errorMessage = error.message;
          } else {
            errorMessage = "An unexpected error occurred";
          }
    
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: errorMessage,
          });
          console.log(error);
        } finally {
    setBenLoading(false);
  }
};
    const createBeneficiaries = async () => {
  setBenLoading(true);
  try {
    const bankAccounts = rowses.map(item => item.accNo);
    const accountNames = rowses.map(item => item.accName);
    const bankNames = rowses.map(item => item.bankName);
    const response = await axios.post(`${BASE_URL}/customer/update-bank`,
      {
        customer_id: currentBeneficiaryId,
        bank_name: bankNames,
        account_name: accountNames,
        account_number: bankAccounts
      },
      { headers }
    );
    
    // RESET FORM
    
    // 🔥 REFRESH BOTH: beneficiaryData AND beneficiaryOptions
    // This updates beneficiaryData
    
    setRowses([{ bankName: "", accName: "", accNo: "" }]);
    setShowBeneficiaryAccModal(false);

    setRows(prev => 
      prev.map(r => ({
        ...r,
        beneficiaryId: null,
        accountId: null,
        accountOptions: [] // force re-fetch of account options
      }))
    );
    
    // 🔥 FORCE RELOAD BENEFICIARY OPTIONS
    // If a payment type is selected, reload based on that type
    if (selectedPaymentType) {
      await loadBeneficiaryData();
    } else {
      // If no payment type selected (general case), refresh from beneficiaryData
      const updatedBeneficiaries = await fetchPayablesAndReturn();
      setBeneficiaryOptions(
        updatedBeneficiaries.map(b => ({
          label: b.name,
          value: b.id,
          supplierName: b.name,
          balance: b?.balance,
        }))
      );
    }
    
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });

  } catch (error) {
  let errorMessage;
    
          // Attempt to extract the error message
          if (error.response && error.response.data) {
            // If message is an object, attempt to stringify it
            if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            } else {
              errorMessage = error.response.data.message;
            }
          } else if (error.message) {
            errorMessage = error.message;
          } else {
            errorMessage = "An unexpected error occurred";
          }
    
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: errorMessage,
          });
          console.log(error);
        } finally {
    setBenLoading(false);
  }
};

    const fetchAccounts = async () => {
      const token = localStorage.getItem("userToken");
      // if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account/expenses`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
     
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };

  useEffect(() => {
    if (showPay) {
      fetchAccounts();
    }
  }, [showPay]);

 

    const fetchReceivables = async () => {
      const token = localStorage.getItem("userToken");
      // if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account/receivables`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
     
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setReceivables(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setReceivables([]);
      } finally {
        setAccountsLoading(false);
      }
    };

  useEffect(() => {
    if (showPay) {
      fetchReceivables();
    }
  }, [showPay]);

  const [loanReceivables, setLoanReceivables] =  useState([]);
    const fetchStatutory = async () => {
      const token = localStorage.getItem("userToken");
      // if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account/staturory_accounts`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
     
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setStatutory(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setStatutory([]);
      } finally {
        setAccountsLoading(false);
      }
    };
    const fetchLoanAccts = async () => {
      const token = localStorage.getItem("userToken");
      // if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/get-loans-receivables`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
     
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setLoanReceivables(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setLoanReceivables([]);
      } finally {
        setAccountsLoading(false);
      }
    };

  useEffect(() => {
    if (showPay) {
      fetchStatutory();
      fetchLoanAccts();
    }
  }, [showPay]);

   useEffect(() => {
    if (showRetrievePay) {
      fetchAccounts();
      fetchStatutory();
      fetchReceivables();
      fetchLoanAccts();
    }
  }, [showRetrievePay]);
   useEffect(() => {
    if (showRetrievePaySaved) {
      fetchAccounts();
      fetchStatutory();
      fetchReceivables();
      fetchLoanAccts();
    }
  }, [showRetrievePaySaved]);

  const duplicateRow = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const emptyRow = {
        accountId: "",
        accountDisplay: "",
        amount: "",
        showDropdown: false,
      };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChanges = (index, field, value) => {
    const updatedRows = [...rowses];
    updatedRows[index][field] = value;
    setRowses(updatedRows);
  };

  const handleChange = (index, field, value) => {
    setRows((prev) => {
      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "showDropdown") {
        row.showDropdown = value;
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_name ?? value?.name ?? ""}`;
        row.accountCode = value?.gl_code ?? value?.code ?? "";
        row.showDropdown = false;
      } else if (field === "accountDisplay") {
        row.accountDisplay = value;
        row.accountId = "";
        row.accountCode = "";
        row.showDropdown = true;
      } else if (field === "amount") {
        row.amount = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };

  

  const totalCredit = parseFloat(totalAmount || 0);
  const totalDebit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );
  const isBalanced = totalDebit === totalCredit;

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("✅ handleSubmit triggered");
    const authToken = localStorage.getItem("authToken");

    // Validate balanced amounts first
    if (!isBalanced) {
      Swal.fire({
        icon: "error",
        title: "Unbalanced Entry",
        text: "Total Debit and Total Credit must balance before saving.",
        confirmButtonColor: "#3085d6",
        customClass: { popup: "swal-highest-zindex" },
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = "99999";
        },
      });
      return;
    }

    setIsSaving(true);

    try {
      // Build base payload
      const typeObj = paymentTypes.find(
        t => (t.name || t.type_name)?.toLowerCase().trim() === paymentTypeLower
      );

      let payload = {
        particulars: reference, // default to reference for compatibility
        description,
        currency: selectedCurrency,
        payment_mode: selectedPaymentMode,
        transaction_date: transactionDate,
        gl_code: debitAccount,
        // total_amount: totalCredit,
        account_id: rows.map((row) => row.accountId).filter(Boolean),
        breakdown_amount: rows.map((row) => parseFloat(row.amount || 0)),
        type_of_payment: typeObj?.id || "",
      };

      // adjust payload depending on payment type
      if (paymentTypeLower.includes("general")) {
        payload.particulars = reference;
      } else if (paymentTypeLower.includes("supplier")) {
        // if supplier, payment_to expected by backend
        payload.payment_to = reference;
        // remove particulars to avoid confusion if backend doesn't expect it
        delete payload.particulars;
      }

      console.log("Submitting payload:", payload);

      const response = await axios.post(
        `${BASE_URL}/v1/post-payments`,
        payload,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          imageUrl: verified,
          title: "Payment Saved",
          text:
            response.data?.message ||
            "The payment has been successfully saved!",
          confirmButtonText: "Print",
          confirmButtonColor: "#16A34A",
          customClass: { popup: "swal-highest-zindex" },
          didOpen: () => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) swalContainer.style.zIndex = "99999";
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const receiptData = {
              reference,
              transactionDate,
              description,
              selectedCurrency,
              selectedPaymentMode,
              debitAccount,
              // totalAmount: totalCredit,
              rows,
            };

            navigate("/preview", {
              state: { invoice: receiptData },
            });
          } else {
            // reset form values (keep structure same as your original)
            setRows([
              {
                accountId: "",
                accountDisplay: "",
                accountCode: "",
                amount: "",
                description: "",
                showDropdown: false,
              },
            ]);
            setReference("");
            setDescription("");
            setDebitAccount("");
            setTotalAmount("");
            setSelectedPaymentMode("");
            setTransactionDate("");
            setIsSaving(false);
            // onClose();
          }
        });
      }
    } catch (error) {
      console.error("Save error:", error);
      Swal.fire({
        imageUrl: crop,
        title: "Save Failed",
        text:
          typeof error.response?.data?.message === "object"
            ? Object.values(error.response.data.message).flat().join(", ")
            : error.response?.data?.message ||
            "An error occurred while saving the payment. Please try again.",
        confirmButtonColor: "#000000ff",
        customClass: { popup: "swal-highest-zindex" },
        didOpen: () => {
          const swalContainer = document.querySelector(".swal2-container");
          if (swalContainer) swalContainer.style.zIndex = "99999";
        },
      });
    } finally {
      setIsSaving(false);
    }
  };

  
  const fetchDebit1 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/bank-accounts`,{headers});
    
      const debt1 = response.data?.data;
      const oopt1 = debt1.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
     
        
      }));
      setDebit1(oopt1);
 

  
    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };
const fetchDebit2 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/cash`,{headers});
    
      const debt2 = response.data?.data;
      const oopt2 = debt2.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
     
        
      }));
      setDebit2(oopt2);
 

  
    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
if (bearer) {
// fetchCurrency();
// fetchMode();
fetchDebit1();
    fetchDebit2();
//   fetchTotalExpenses();
}
}, [bearer]);

  useEffect(() => {
    const fetchDebitAccounts = async () => {
      if (!selectedPaymentMode) return;
      const token = localStorage.getItem("authToken");
      let endpoint = "";

      const selectedModeName = paymentModes.find(m => m.id == selectedPaymentMode)?.name?.toLowerCase();

      if (selectedModeName?.includes("bank") || selectedModeName?.includes("transfer") || selectedModeName?.includes("teller")) {
        endpoint = `${BASE_URL}/bank-accounts`;
      } else if (selectedModeName?.includes("cheque") || selectedModeName?.includes("cash")) {
        endpoint = `${BASE_URL}/cash`;
      }

      if (!endpoint) return;

      setDebitAccountsLoading(true); // ✅ Start loader

      try {
        const res = await axios.get(endpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (res.data && Array.isArray(res.data.data)) {
          const options = res.data.data.map((item) => ({
            value: item.id,
            label: item.gl_name || item.name,
          }));
          setExpenseOptions(options);
        } else {
          setExpenseOptions([]);
        }
      } catch (err) {
        console.error("Error fetching debit account options:", err);
        setExpenseOptions([]);
      } finally {
        setDebitAccountsLoading(false); // ✅ Stop loader
      }
    };

    fetchDebitAccounts();
  }, [selectedPaymentMode, paymentModes]);

  
  const debitedAccount = rows.map((row) => row.accountId || "");
const debitedAmount = rows.map((row) => row.amount || "");

  const handleFetchPayments = async () => {
  setIsSaving(true);

  try {
    const payableIds = rows.map(row => row.beneficiaryId);
    const accountIds = rows.map(row => row.debitAccount);
    const beneficiaryBankIds = rows.map(row => row.accountId);
    const amounts = rows.map(row => row.amountToPay || 0);
const supplierNames = [...new Set(rows.map(r => r.supplierName))];
    const payload = {
      // transaction_date: transactionDate,
      // payment_mode: selectedPayment,
      // bank_id: selectedBank?.value || selectedBank,
      // beneficiary_id: payableIds,
      // beneficiary_bank_id: beneficiaryBankIds,
      // amount: amounts,
      receipt_number: journalReference,
      // receipt_type: selectedPaymentType,
      // account_id: accountIds
    };

    const response = await axios.post(
      `${BASE_URL}/make_beneficiary_payment`,
      payload,
      { headers }
    );

    // Swal.fire({
    //   icon: "success",
    //   title: "Success",
    //   text: response.data.message,
    // });

    // ⭐ ROUTING BASED ON PAYMENT TYPE
    // if (selectedPayment === "bank transfer") {
    //   navigate("/payable_instruction", {
    //     state: {
    //       rowsToPass: rows,
    //       selectedBankName: selectedBank?.label,
    //       selectedBankAc: selectedBank?.account,
    //       batchNumber: journalReference
    //     }
    //   });

    // } else if (selectedPayment === "cheque") {
    //   navigate("/payable_cheque", {
    //     state: {
    //       rawInvoice: rows,
    //       supplierNames: supplierNames,
    //     }
    //   });
    // }

    // (optional reset if page does not navigate immediately)
    // setSelectedPayment("");
    // setTransactionDate("");
    // setSelectedBank(null);
handleClosePay();
handleCloseRetrievePay()
handleCloseRetrievePaySaved()
fetchExpenses();
setJournalReference('');
  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";

    if (error.response?.data?.message) {
      errorMessage = typeof error.response.data.message === "string"
        ? error.response.data.message
        : JSON.stringify(error.response.data.message);
    }

    Swal.fire({ icon: "error", title: "Oops...", text: errorMessage });

  } finally {
    setIsSaving(false);
  }
};

  const handleFetchPaymentsx = async () => {
  setIsSaving(true);

  try {
    const payableIds = rows.map(row => row.beneficiaryId);
    const accountIds = rows.map(row => row.debitAccount);
    const beneficiaryBankIds = rows.map(row => row.accountId);
    const amounts = rows.map(row => row.amountToPay || 0);
const supplierNames = [...new Set(rows.map(r => r.supplierName))];
    const payload = {
      // transaction_date: transactionDate,
      // payment_mode: selectedPayment,
      // bank_id: selectedBank?.value || selectedBank,
      // beneficiary_id: payableIds,
      // beneficiary_bank_id: beneficiaryBankIds,
      // amount: amounts,
      receipt_number: viewData[0]?.receipt_number,
      // receipt_type: selectedPaymentType,
      // account_id: accountIds
    };

    const response = await axios.post(
      `${BASE_URL}/make_beneficiary_payment`,
      payload,
      { headers }
    );

    // Swal.fire({
    //   icon: "success",
    //   title: "Success",
    //   text: response.data.message,
    // });

    // ⭐ ROUTING BASED ON PAYMENT TYPE
    // if (selectedPayment === "bank transfer") {
    //   navigate("/payable_instruction", {
    //     state: {
    //       rowsToPass: rows,
    //       selectedBankName: selectedBank?.label,
    //       selectedBankAc: selectedBank?.account,
    //       batchNumber: journalReference
    //     }
    //   });

    // } else if (selectedPayment === "cheque") {
    //   navigate("/payable_cheque", {
    //     state: {
    //       rawInvoice: rows,
    //       supplierNames: supplierNames,
    //     }
    //   });
    // }
handleCloseRetrievePay();
handleCloseRetrievePaySaved()
fetchExpenses();

    // (optional reset if page does not navigate immediately)
    // setSelectedPayment("");
    // setTransactionDate("");
    // setSelectedBank(null);

  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";

    if (error.response?.data?.message) {
      errorMessage = typeof error.response.data.message === "string"
        ? error.response.data.message
        : JSON.stringify(error.response.data.message);
    }

    Swal.fire({ icon: "error", title: "Oops...", text: errorMessage });

  } finally {
    setIsSaving(false);
  }
};

const[lineLoading, setLineLoading] = useState(false);
const[viewData, setViewData] = useState([]);



const handleAddLineAPI = async () => {
 console.log(rows)
  setLineLoading(true);

  try {
    const lastRow = rows[rows.length - 1];
    console.log(lastRow)

    // ------------------------------------
    // ⭐ BASE PAYLOAD (always included)
    // ------------------------------------
  let payload = {
  receipt_type: selectedPaymentType,
  transaction_date: transactionDate,
  payment_mode: selectedPayment,
  bank_id: selectedBank?.value,
  receipt_number: journalReference,
  amount: lastRow.amountToPay || 0,
  payment_description: lastRow.description || "",
};

if (selectedPaymentType == 7) {
  payload.payable_id = lastRow.beneficiaryId;
  payload.beneficiary_bank_id = lastRow.accountId;
}



    // ------------------------------------
    // ⭐ CONDITIONAL FIELDS BY PAYMENT TYPE
    // ------------------------------------

   if (["1", "2", "4", "6"].includes(selectedPaymentType)) {
      // Supplier / Contractor beneficiaries
      payload = {
        ...payload,
        beneficiary_id: lastRow.beneficiaryId,
        beneficiary_bank_id: lastRow.accountId,
        account_id: lastRow.debitAccount,
      };
    }
    // else if (selectedPaymentType === "2") {
    //   // Supplier / Contractor beneficiaries
    //   payload = {
    //     ...payload,
    //     particulars: lastRow.beneficiaryId,
    //     beneficiary_bank_id: lastRow.accountId,
    //     account_id: lastRow.debitAccount,
    //   };
    // }

    else if (selectedPaymentType === "3") {
      // LOAN CUSTOMERS
      payload = {
        ...payload,
        loan_account_id: selectedLoanAccounts?.value || "",
        customer_id: lastRow.beneficiaryId,
        customer_bank_id: lastRow.accountId,
        account_id: lastRow.debitAccount,
      };
    }

    else if (selectedPaymentType === "5") {
      // ADVANCE CUSTOMERS
      payload = {
        ...payload,
        customer_id: lastRow.beneficiaryId,
        customer_bank_id: lastRow.accountId,
        account_id: lastRow.debitAccount,
      };
    }

    // DEBUG: console.log(payload);

    // ------------------------------------
    // ⭐ API CALL
    // ------------------------------------
    const res = await axios.post(
      `${BASE_URL}/add-beneficiary-payment`,
      payload,
      { headers }
    );
setRows(prev => {
  const copy = [...prev];
  copy[prev.length - 1].locked = true;  // 🔒 LOCK LAST ROW
  return copy;
});
    setViewData(res.data.data);

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Add Line Failed",
      text: JSON.stringify(err?.response?.data?.message),
    });
  } finally {
    setLineLoading(false);
  }
};
const handleAddLineAPIs = async () => {
  setLineLoading(true);

  try {
    const lastRow = rows[rows.length - 1];

    // ------------------------------------
    // ⭐ BASE PAYLOAD (always included)
    // ------------------------------------
    let payload = {
      receipt_type: selectedPaymentType,
      transaction_date: transactionDate,
      payment_mode: selectedPayment,
      bank_id: selectedBank?.value,
      receipt_number: journalReference,
      payment_description: lastRow.description || 0,

      // Shared optional fields (may be unused depending on type)
      amount: lastRow.amountToPay || 0,
      
    };
    if (selectedPaymentType == 7) {
  payload.payable_id = lastRow.beneficiaryId;
  payload.beneficiary_bank_id = lastRow.accountId;
}

    // ------------------------------------
    // ⭐ CONDITIONAL FIELDS BY PAYMENT TYPE
    // ------------------------------------

    if (["1", "2", "4", "6"].includes(selectedPaymentType)) {
      // Supplier / Contractor beneficiaries
      payload = {
        ...payload,
        beneficiary_id: lastRow.beneficiaryId,
        beneficiary_bank_id: lastRow.accountId,
        account_id: lastRow.debitAccount,
      };
    }
    // else if (selectedPaymentType === "2") {
    //   // Supplier / Contractor beneficiaries
    //   payload = {
    //     ...payload,
    //     particulars: lastRow.beneficiaryId,
    //     beneficiary_bank_id: lastRow.accountId,
    //     account_id: lastRow.debitAccount,
    //   };
    // }

    else if (selectedPaymentType === "3") {
      // LOAN CUSTOMERS
      payload = {
        ...payload,
        loan_account_id: selectedLoanAccounts?.value || "",
        customer_id: lastRow.beneficiaryId,
        customer_bank_id: lastRow.accountId,
        account_id: lastRow.debitAccount,
      };
    }

    else if (selectedPaymentType === "5") {
      // ADVANCE CUSTOMERS
      payload = {
        ...payload,
        customer_id: lastRow.beneficiaryId,
        customer_bank_id: lastRow.accountId,
        account_id: lastRow.debitAccount,
      };
    }

    // DEBUG: console.log(payload);

    // ------------------------------------
    // ⭐ API CALL

    // ------------------------------------
    const res = await axios.post(
      `${BASE_URL}/add-beneficiary-payment`,
      payload,
      { headers }
    );
setRows(prev => {
  const copy = [...prev];
  copy[prev.length - 1].locked = true;  // 🔒 LOCK LAST ROW
  return copy;
});
    setViewData(res.data.data);

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Add Line Failed",
      text: JSON.stringify(err?.response?.data?.message),
    });
  } finally {
    setLineLoading(false);
  }
};
const handleAddLineAPIsSaved = async () => {
  setLineLoading(true);

  try {
    const lastRow = rows[rows.length - 1];

    // ------------------------------------
    // ⭐ BASE PAYLOAD (always included)
    // ------------------------------------
    let payload = {
      receipt_type: selectedPaymentType,
      transaction_date: transactionDate,
      payment_mode: selectedPayment,
      bank_id: selectedBank?.value,
      receipt_number: journalReference,
      payment_description: lastRow.description || 0,

      // Shared optional fields (may be unused depending on type)
      amount: lastRow.amountToPay || 0,
      
    };

    if (selectedPaymentType == 7) {
  payload.payable_id = lastRow.beneficiaryId;
  payload.beneficiary_bank_id = lastRow.accountId;
}

    // ------------------------------------
    // ⭐ CONDITIONAL FIELDS BY PAYMENT TYPE
    // ------------------------------------

    if (["1", "2", "4", "6"].includes(selectedPaymentType)) {
      // Supplier / Contractor beneficiaries
      payload = {
        ...payload,
        beneficiary_id: lastRow.beneficiaryId,
        beneficiary_bank_id: lastRow.accountId,
        account_id: lastRow.debitAccount,
      };
    }
    // else if (selectedPaymentType === "2") {
    //   // Supplier / Contractor beneficiaries
    //   payload = {
    //     ...payload,
    //     particulars: lastRow.beneficiaryId,
    //     beneficiary_bank_id: lastRow.accountId,
    //     account_id: lastRow.debitAccount,
    //   };
    // }

    else if (selectedPaymentType === "3") {
      // LOAN CUSTOMERS
      payload = {
        ...payload,
        loan_account_id: selectedLoanAccounts?.value || "",
        customer_id: lastRow.beneficiaryId,
        customer_bank_id: lastRow.accountId,
        account_id: lastRow.debitAccount,
      };
    }

    else if (selectedPaymentType === "5") {
      // ADVANCE CUSTOMERS
      payload = {
        ...payload,
        customer_id: lastRow.beneficiaryId,
        customer_bank_id: lastRow.accountId,
        account_id: lastRow.debitAccount,
      };
    }

    // DEBUG: console.log(payload);

    // ------------------------------------
    // ⭐ API CALL
    
    // ------------------------------------
    const res = await axios.post(
      `${BASE_URL}/add-to-saved-beneficiary-payment`,
      payload,
      { headers }
    );
setRows(prev => {
  const copy = [...prev];
  copy[prev.length - 1].locked = true;  // 🔒 LOCK LAST ROW
  return copy;
});
    setViewData(res.data.data);

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Add Line Failed",
      text: JSON.stringify(err?.response?.data?.message),
    });
  } finally {
    setLineLoading(false);
  }
};

const handleSelectReference = async (ref) => {
  setSelectedReference(ref);

  Swal.fire({
    title: "Loading...",
    text: "Fetching payment details",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    const receiptNumber =
      ref.raw?.receipt_number ||
      ref.label.split(" - ")[0];

    const res = await axios.get(
      `${BASE_URL}/processed-beneficiary-payment-details`,
      {
        params: { receipt_number: receiptNumber },
        headers
      }
    );

    Swal.close();

    setShowReferenceModal(false);
    // setJournalReference(res.)
    setJournalReference(res.data.data[0]?.receipt_number)
    setShowRetrievePay(true);
    

    setViewData(res.data.data);
setSelectedPaymentType(res.data.data[0]?.receipt_type?.toString() || "");
  } catch (err) {
    Swal.close();

    Swal.fire({
      icon: "error",
      title: "Failed to fetch details",
      text: err?.response?.data?.message || "Something went wrong.",
    });

    setShowReferenceModal(true);
  }
};

const handleEyeReference =  async(item,value)  => {
  setisSaved(value)
setSelectedReference(item?.receipt_number);
 Swal.fire({
    title: "Loading...",
    text: "Fetching payment details",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => Swal.showLoading(),
  });

   try {
    const receiptNumber = item.receipt_number

    const res = await axios.get(
      `${BASE_URL}/all-beneficiary-payment-details`,
      {
        params: { receipt_number: receiptNumber },
        headers
      }
    );

    Swal.close();

    // setJournalReference(res.)
    setJournalReference(res.data.data[0]?.receipt_number)
    setShowRetrievePaySaved(true);
    

    setViewData(res.data.data);
setSelectedPaymentType(res.data.data[0]?.receipt_type?.toString() || "");
  } catch (err) {
    Swal.close();

    Swal.fire({
      icon: "error",
      title: "Failed to fetch details",
      text: err?.response?.data?.message || "Something went wrong.",
    });
  }

}

const handleDeleteReviewRow = async (index, row) => {
  const idToDelete = row?.id; // backend payment ID

  if (!idToDelete) {
    return Swal.fire("Error", "This row has no ID and cannot be deleted.", "error");
  }

  // 🟡 1. Ask for confirmation
  const confirm = await Swal.fire({
    title: "Are you sure?",
    text: "This payment line will be permanently deleted.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) return;

  // 🟠 2. Start loading Swal
  Swal.fire({
    title: "Deleting...",
    text: "Please wait",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => Swal.showLoading()
  });

  try {
    // 🟣 3. Call DELETE API
        const api = isSaved ? "delete_saved_payment" : "delete_customized_payment"

    await axios.post(
      `${BASE_URL}/delete_customized_payment`,
      { id: idToDelete },
      { headers }
    );

    // 🟢 4. Remove from PAYMENT REVIEW table
    const updatedReview = [...viewData];
    updatedReview.splice(index, 1);
    setViewData(updatedReview);

    // 🟢 5. Remove same row from PAYMENT BREAKDOWN
    const updatedBreakdown = [...rows];
    updatedBreakdown.splice(index, 1);
    setRows(updatedBreakdown);

    // 🟢 6. Success
    Swal.fire({
      icon: "success",
      title: "Deleted",
      text: "The payment line has been removed.",
      timer: 1500
    });

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Delete Failed",
      text: err?.response?.data?.message || "Could not delete payment."
    });

  }
};

const handleDeleteReviewRowSaved= async (index, row) => {
  const idToDelete = row?.id; // backend payment ID

  if (!idToDelete) {
    return Swal.fire("Error", "This row has no ID and cannot be deleted.", "error");
  }

  // 🟡 1. Ask for confirmation
  const confirm = await Swal.fire({
    title: "Are you sure?",
    text: "This payment line will be permanently deleted.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) return;

  // 🟠 2. Start loading Swal
  Swal.fire({
    title: "Deleting...",
    text: "Please wait",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => Swal.showLoading()
  });

  try {

    await axios.post(
      `${BASE_URL}/delete_saved_payment`,
      { id: idToDelete },
      { headers }
    );

    // 🟢 4. Remove from PAYMENT REVIEW table
    const updatedReview = [...viewData];
    updatedReview.splice(index, 1);
    setViewData(updatedReview);

    // 🟢 5. Remove same row from PAYMENT BREAKDOWN
    const updatedBreakdown = [...rows];
    updatedBreakdown.splice(index, 1);
    setRows(updatedBreakdown);

    // 🟢 6. Success
    Swal.fire({
      icon: "success",
      title: "Deleted",
      text: "The payment line has been removed.",
      timer: 1500
    });

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Delete Failed",
      text: err?.response?.data?.message || "Could not delete payment."
    });

  }
};



// useEffect(() => {
//   const total = rows.reduce((sum, r) => sum + Number(r.amountToPay || 0), 0);
//   setTotalAmount(total);
// }, [rows]);

useEffect(() => {
  // Check if there is data in the Review Table
  if (viewData && viewData.length > 0) {
    
    const total = viewData.reduce((sum, item) => {
      return sum + Number(item.amount || 0);
    }, 0);

    setTotalAmount(total);
  } else {
    setTotalAmount(0);
  }
}, [viewData]); 
  const handleFetchPaymentss = async () => {
  setIsSaving(true);

  try {
    const payableIds = extraRows.map(row => row.beneficiaryId);
    const beneficiaryBankIds = extraRows.map(row => row.accountId);
    const amounts = extraRows.map(row => row.amountToPay || 0);
    const accountIds = extraRows.map(row => row.debitAccount);
const supplierNames = [...new Set(extraRows.map(r => r.supplierName))];
    const payload = {
      transaction_date: viewPaymentData[0]?.transaction_date,
      payment_mode: viewPaymentData[0]?.mode?.name,
      bank_id: viewPaymentData[0]?.debit_account_data?.id,
      beneficiary_id: payableIds,
      beneficiary_bank_id: beneficiaryBankIds,
      amount: amounts,
       account_id: accountIds,
      receipt_number: viewPaymentData[0]?.receipt_number
    };

    const response = await axios.post(
      `${BASE_URL}/process-beneficiary-payment`,
      payload,
      { headers }
    );
    Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });
      
      setShowViewModal(false)
      fetchExpenses();
    // ⭐ ROUTING BASED ON PAYMENT TYPE
    // if (selectedPayment === "bank transfer") {
    //   navigate("/payable_instruction", {
    //     state: {
    //       rowsToPass: rows,
    //       selectedBankName: selectedBank?.label,
    //       selectedBankAc: selectedBank?.account,
    //       batchNumber: journalReference
    //     }
    //   });

    // } else if (selectedPayment === "cheque") {
    //   navigate("/payable_cheque", {
    //     state: {
    //       rawInvoice: rows,
    //       supplierNames: supplierNames,
    //     }
    //   });
    // }

    // (optional reset if page does not navigate immediately)
    // setSelectedPayment("");
    // setTransactionDate("");
    // setSelectedBank(null);

  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";

    if (error.response?.data?.message) {
      errorMessage = typeof error.response.data.message === "string"
        ? error.response.data.message
        : JSON.stringify(error.response.data.message);
    }

    Swal.fire({ icon: "error", title: "Oops...", text: errorMessage });

  } finally {
    setIsSaving(false);
  }
};

  // const handleEdit = async (uuid) => {
  //   handleShowEdit();
  //   setPayLoad(true); 
  //   setError(null); 
  //   setSelectedPayment(null);
  //   try {
   
  //     const res = await axios.get(`${BASE_URL}/fetch_payments_by_uuid?uuid=${uuid}`,{ headers });
     
  //     const results = res.data?.data;
  //     const resultx = res.data?.data?.total;

  //     console.log(res, "full payments");
    
  //     const normalizedResults = Array.isArray(results) ? results : [results];
  //     setSelectedPayment(normalizedResults);
  //     console.log(results, "ssspayments");
  //   } catch (error) {
  //     const errorStatus = error.response?.data?.message;
  //     console.log(errorStatus);
  //     setSelectedPayment([]);
  //   } finally {
  //     setPayLoad(false);
  //   }
  // };
const handlePrint = async (receipt_number) => {
  if (!receipt_number) {
    Swal.fire("Error", "Invalid receipt number passed.", "error");
    return;
  }

  Swal.fire({
    title: "Loading...",
    text: "Fetching payment details...",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    const response = await axios.get(
      `${BASE_URL}/fetch-payable-payment-details?receipt_number=${receipt_number}`,
      { headers }
    );

    Swal.close();
const data = response.data?.data;   
    // API sometimes returns array-like {0: {...}, 1: {...}}
    // const data = Array.isArray(response.data)
    //   ? response.data[0]
    //   : response.data[0] || response.data?.data || response.data;

    if (!data) {
      throw new Error("Invalid API response. No payment record found.");
    }

    // Extract payment type from server
    const paymentType = data[0]?.mode?.name?.toLowerCase(); 
    // Example: "Cheque" → "cheque", "Bank Transfer" → "bank transfer"

    // Always verify first
    console.log("Payment type from API:", paymentType);
    console.log("Full API data:", data);

    // Navigate based on payment type
    if (paymentType === "bank transfer") {
      navigate("/payable_instruction", {
        state: {
          rowsToPass: data,        // send the actual payment record
          selectedBankName: data[0]?.debit_account_data?.gl_name,
          selectedBankAc: data[0]?.debit_account_data?.gl_code,
          batchNumber: data[0]?.receipt_number
        }
      });

    } else if (paymentType === "cheque") {
      navigate("/payable_cheque", {
        state: {
          rawInvoice: data,
          supplierNames: data?.supplier?.name,
        }
      });

    } else {
      Swal.fire({
        icon: "error",
        title: "Unknown Payment Type",
        text: `The system returned an unknown payment mode: "${data?.mode?.name}"`,
      });
    }

  } catch (error) {
    console.error("Print Error:", error);
    Swal.close();

    let message = "Failed to load payment details.";

    if (error.response?.data?.message) {
      message =
        typeof error.response.data.message === "string"
          ? error.response.data.message
          : JSON.stringify(error.response.data.message);
    }

    Swal.fire({
      icon: "error",
      title: "Error",
      text: message,
      confirmButtonText: "OK",
    });
  }
};

const handlePrints = async (receipt_number) => {
  if (!receipt_number) {
    Swal.fire("Error", "Invalid receipt number passed.", "error");
    return;
  }

  Swal.fire({
    title: "Loading...",
    text: "Fetching payment details...",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    const response = await axios.get(
      `${BASE_URL}/fetch-payable-payment-details?receipt_number=${receipt_number}`,
      { headers }
    );

    Swal.close();
const data = response.data?.data;   
    // API sometimes returns array-like {0: {...}, 1: {...}}
    // const data = Array.isArray(response.data)
    //   ? response.data[0]
    //   : response.data[0] || response.data?.data || response.data;

    if (!data) {
      throw new Error("Invalid API response. No payment record found.");
    }

    // Extract payment type from server
    const paymentType = data[0]?.mode?.name?.toLowerCase(); 
    // Example: "Cheque" → "cheque", "Bank Transfer" → "bank transfer"

    // Always verify first
    console.log("Payment type from API:", paymentType);
    console.log("Full API data:", data);

    // Navigate based on payment type
    if (paymentType === "bank transfer") {
      navigate("/payable_new_instruction", {
        state: {
          from: 'bulk_payment_entries',
          rowsToPass: data,        // send the actual payment record
          selectedBankName: data[0]?.debit_account_data?.gl_name,
          selectedBankAc: data[0]?.debit_account_data?.gl_code,
          batchNumber: data[0]?.receipt_number,
          payDetails: data.map(item => item.payment_description),
        }
      });

    } else if (paymentType === "cheque") {
      navigate("/payable_cheque", {
        state: {
          rawInvoice: data,
          supplierNames: data?.supplier?.name,
        }
      });

    } else {
      Swal.fire({
        icon: "error",
        title: "Unknown Payment Type",
        text: `The system returned an unknown payment mode: "${data?.mode?.name}"`,
      });
    }

  } catch (error) {
    console.error("Print Error:", error);
    Swal.close();

    let message = "Failed to load payment details.";

    if (error.response?.data?.message) {
      message =
        typeof error.response.data.message === "string"
          ? error.response.data.message
          : JSON.stringify(error.response.data.message);
    }

    Swal.fire({
      icon: "error",
      title: "Error",
      text: message,
      confirmButtonText: "OK",
    });
  }
};

  
const handleView = async (receipt_number) => {
  if (!receipt_number) {
    Swal.fire("Error", "Invalid receipt number passed.", "error");
    return;
  }
  

  Swal.fire({
    title: "Loading...",
    text: "Fetching payment details...",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    const response = await axios.get(
      `${BASE_URL}/fetch-payable-payment-details?receipt_number=${receipt_number}`,
      { headers }
    );

    Swal.close(); // stop loader

    if (!response.data?.data) {
      throw new Error("No data returned from server.");
    }

    setViewPaymentData(response.data.data);
    setShowViewModal(true);

  } catch (error) {
    console.error("View Error:", error);

    Swal.close(); // ALWAYS stop loader on error

    let message = "Failed to load payment details.";

    if (error.response?.data?.message) {
      message = typeof error.response.data.message === "string"
        ? error.response.data.message
        : JSON.stringify(error.response.data.message);
    }

    Swal.fire({
      icon: "error",
      title: "Error",
      text: message,
      confirmButtonText: "OK", // ensures OK button shows
    });
  }
};

const originalTotal = viewPaymentData?.reduce(
  (sum, item) => sum + Number(item.amount || 0),
  0
);

const extraTotal = extraRows.reduce(
  (sum, row) => sum + Number(row.amountToPay || 0),
  0
);

const grandTotal = originalTotal + extraTotal;


useEffect(() => {
  const fetchReference = async () => {
    console.log('in the Tokennssss');
    const token = localStorage.getItem("userToken");
    if (!token) return;
    setLoadingRef(true);
    try {
      const res = await axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (res?.data) {
        const payload = res.data;
        const d =
          payload?.data ??
          payload?.code ??
          payload?.reference ??
          payload?.number ??
          payload?.data?.code;
        let ref = "";
        if (typeof d === "string" || typeof d === "number") {
          ref = d;
        } else if (d && typeof d === "object") {
          ref = d.code || d.reference || d.number || "";
        }
        setReference(ref ? String(ref) : "");
      }
    } catch (error) {
      console.error("Error fetching journal reference:", error);
    } finally {
      setLoadingRef(false);
    }
  };

  if (showRev) {
    fetchReference();
  }
}, [showRev]);


const handleShowRev = async (uuid) => {
  setReverseLoading(uuid);
  setShowRev(true);
  try {
    const response = await axios.get(`${BASE_URL}/fetch_journals_by_uuid?uuid=${uuid}`, { headers });
    const result = response.data.data;
    setShowRev(true);
    setJournalls(result);
    setSelectedUUID(uuid);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: JSON.stringify(error.response.data.message),
      });
      console.log(errorMessage);
    }
  } finally {
    setReverseLoading(null);
  }
};

const fetchNumber = async () => {
    console.log('in the Tokennssss');
    const token = localStorage.getItem("userToken");
    if (!token) return;
    setLoadingRef(true);
    try {
      const res = await axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (res?.data) {
        const payload = res.data;
        const d =
          payload?.data ??
          payload?.code ??
          payload?.reference ??
          payload?.number ??
          payload?.data?.code;
        let ref = "";
        if (typeof d === "string" || typeof d === "number") {
          ref = d;
        } else if (d && typeof d === "object") {
          ref = d.code || d.reference || d.number || "";
        }
        setReference(ref ? String(ref) : "");
      }
    } catch (error) {
      console.error("Error fetching journal reference:", error);
    } finally {
      setLoadingRef(false);
    }
  };

const handleRevClick = async (selectedUUID) => {
 
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to reverse this payment.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#01036bff',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, reverse it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) {
    return; // User canceled, do nothing
  }
  setReverseLoading2(true);    
  try {

    const response = await axios.get(`${BASE_URL}/reverse-payment?uuid=${selectedUUID}`, { headers });

    fetchExpenses();
    // toast.success(response.data.message);

    // setTrashClicked(true);
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    
    handleCloseRev();
    fetchExpenses();

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      setUploadLoading(false);
      console.log(errorMessage);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
    }
  }
    finally {
    setReverseLoading2(false);
  }
};


  
const calculateTotals = () => {
  let totalDebits = 0;
  let totalCredits = 0;

  journalls?.forEach((item) => {
    totalDebits += parseFloat(item?.debit || 0);
    totalCredits += parseFloat(item?.credit || 0);
  });

  return { totalDebits, totalCredits };
};

const { totalDebits, totalCredits } = calculateTotals();




const list =
  selectedPaymentType === "4"
    ? statutory
    : selectedPaymentType === "5"
    ? receivables
    : selectedPaymentType === "3"
    ? loanReceivables
    : accounts;


const formattedList = list.map(acc => ({
  value: acc.id,
  label: `${acc.gl_code ?? acc.code ?? ""} - ${acc.gl_name ?? acc.name ?? ""}`,
  raw: acc        // keep original object if needed later
}));

const totalAmountRetrieve = 
  viewData.reduce((sum, v) => sum + Number(v.amount || 0), 0);

const beneficiaryDropdownOptions =
  selectedPaymentType !== "3" && selectedPaymentType !== "5"
    ? [
        { label: "➕ Add New Beneficiary", value: "__add_new__", isAddNew: true },
        ...beneficiaryOptions,
      ]
    : beneficiaryOptions; // For types 3 and 5 → No Add New


    const accountOptionsForLoan = [
  ...(rows.accountOptions || []),
  {
    label: "➕ Add Beneficiary Account",
    value: "__add_beneficiary_account__",
    isAddNew: true
  }

];

const [beneficiaryAccounts, setBeneficiaryAccounts] = useState({});
const [accBank, setAccBank] = useState("");
const [accNames, setAccNames] = useState("");
const [accNos, setAccNos] = useState("");

const addNewBeneficiaryAccount = (beneficiaryId) => {
  if (!accBank || !accName || !accNo) return;

  setBeneficiaryAccounts(prev => ({
    ...prev,
    [beneficiaryId]: [
      ...(prev[beneficiaryId] || []),
      { bankName: accBank, accountName: accName, accountNumber: accNo }
    ]
  }));

  setAccBank("");
  setAccName("");
  setAccNo("");
};

const removeBeneficiaryAccount = (beneficiaryId, index) => {
  setBeneficiaryAccounts(prev => ({
    ...prev,
    [beneficiaryId]: prev[beneficiaryId].filter((_, i) => i !== index)
  }));
};

const paymentTypeMap = {
  "1": "Supplier Payment Entries",
  "2": "General Payment Entries",
  "3": "Loan Disbursement Entries",
  "4": "Statutory Payment Entries",
  "5": "Cash Advances Entries",
  "6": "Fixed Asset Purchase Entries",
};

const formatCurrency = (val) => {
  const num = Number(val || 0);
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

const formatDate = (val) => {
  if (!val) return "";
  const d = new Date(val);
  return isNaN(d) ? val : d.toLocaleDateString();
};


// const createDownload = async () => {
//   setIsSaving(true);

//   try {
//     const payload = {
//       receipt_type: selectedPaymentType,
//       payment_mode: selectedPayment,
//       start_date: startDate,
//       end_date: endDate,
//     };

//     const token = localStorage.getItem("userToken");

//     const response = await axios.get(`${BASE_URL}/filter-beneficiary-payment`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json",
//       },
//       params: payload,  // ✅ send payload as query params
//     });
//     const raw = response.data?.data || [];

//     // Normalize extracted fields
//     const rows = raw.map((r) => ({
//       particular: r.particular ?? r.particular_name ?? r.beneficiary_name ?? "",
//       amount: r.amount ?? r.total_amount ?? r.payment_amount ?? 0,
//       description: r.description ?? r.note ?? r.remarks ?? "",
//       transaction_date: r.transaction_date ?? r.date ?? r.created_at ?? "",
//     }));

//     const title = paymentTypeMap[String(selectedPaymentType)] || "Payment Entries";
//     const baseFilename =
//       title.toLowerCase().replace(/\s+/g, "_") + "_" + Date.now();


//     // --------------------------------------------------
//     // ✅ 1. GENERATE EXCEL
//     // --------------------------------------------------
//     const excelSheetData = [
//       ["Particular", "Amount", "Description", "Transaction Date"], // header
//       ...rows.map((r) => [
//         r.particular,
//         formatCurrency(r.amount),
//         r.description,
//         formatDate(r.transaction_date),
//       ]),
//     ];

//     const worksheet = XLSX.utils.aoa_to_sheet(excelSheetData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Entries");

//     XLSX.writeFile(workbook, `${baseFilename}.xlsx`);


//     // --------------------------------------------------
//     // ✅ 2. GENERATE PDF
//     // --------------------------------------------------
//     const doc = new jsPDF("p", "pt");

//     doc.setFontSize(16);
//     doc.text(title, 40, 40);

//     doc.autoTable({
//       startY: 70,
//       head: [["Particular", "Amount", "Description", "Transaction Date"]],
//       body: rows.map((r) => [
//         r.particular,
//         formatCurrency(r.amount),
//         r.description,
//         formatDate(r.transaction_date),
//       ]),
//       theme: "grid",
//       styles: { fontSize: 9 },
//       headStyles: { fillColor: [22, 160, 133] },
//     });

//     doc.save(`${baseFilename}.pdf`);


//     Swal.fire({
//       icon: "success",
//       title: "Success",
//       text: response.data.message,
//     });

//     handleCloseDown();

//   } catch (error) {
//     let errorMessage = "An error occurred. Please try again.";

//     if (error.response?.data?.message) {
//       errorMessage = typeof error.response.data.message === "string"
//         ? error.response.data.message
//         : JSON.stringify(error.response.data.message);
//     }

//     Swal.fire({ icon: "error", title: "Oops...", text: errorMessage });

//   } finally {
//     setIsSaving(false);
//   }
// };


const downloadExcel = async (rows, baseFilename) => {
  try {
    const excelSheetData = [
      ["Particular", "Amount", "Description", "Transaction Date"],
      ...rows.map((r) => [
        r.particular,
        formatCurrency(r.amount),
        r.description,
        formatDate(r.transaction_date),
      ]),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(excelSheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Entries");

    XLSX.writeFile(workbook, `${baseFilename}.xlsx`);

  } catch (err) {
    console.error("Excel generation failed:", err);
    Swal.fire({
      icon: "error",
      title: "Excel Error",
      text: "Could not generate Excel file.",
    });
  }
};

const downloadPDF = async (rows, title, baseFilename) => {
  try {
    const doc = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a4",
    });
    // Set font early to avoid undefined issues
    doc.setFont("helvetica", "normal");
    doc.setFontSize(14);
    doc.text(title, 40, 40);

    // Use functional call instead of prototype method
    autoTable(doc, {
      startY: 70,
      head: [["Particular", "Amount", "Description", "Transaction Date"]],
      body: rows.map(r => [
        r.particular || "",
        formatCurrency(r.amount || 0),
        r.description || "",
        formatDate(r.transaction_date || ""),
      ]),
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: { fillColor: [22, 160, 133] },
    });

    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${baseFilename}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Revoke after short delay
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (err) {
    console.error("PDF generation failed:", err);
    Swal.fire({
      icon: "error",
      title: "PDF Error",
      text: "Could not generate PDF. Check the console for details.",
    });
  }
};

const askDownloadFormat = async () => {
  const result = await Swal.fire({
    title: "Choose Download Format",
    text: "Which format do you want to download?",
    icon: "question",
    showCancelButton: true,
    showDenyButton: true,
    confirmButtonText: "📊 Excel",
    denyButtonText: "📄 PDF",
    cancelButtonText: "Cancel",
    reverseButtons: true,
  });

  if (result.isConfirmed) return "excel";
  if (result.isDenied) return "pdf";
  return null; // cancelled
};



const createDownload = async () => {
  setIsSaving(true);
  setIsSaving1(true);

  try {
    const payload = {
      receipt_type: selectedPaymentType,
      payment_mode: selectedPayment,
      start_date: startDate,
      end_date: endDate,
    };

    const token = localStorage.getItem("userToken");
    const response = await axios.get(
      `${BASE_URL}/filter-beneficiary-payment`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        params: payload,
      }
    );

    const raw = response.data?.data || [];

    const rows = raw.map((r) => ({
      particular: r.particular ?? r.particular_name ?? r.beneficiary_name ?? "",
      amount: r.amount ?? r.total_amount ?? r.payment_amount ?? 0,
      description: r.payment_description ?? r.note ?? r.remarks ?? "",
      transaction_date: r.transaction_date ?? r.date ?? r.created_at ?? "",
    }));

    if (!rows.length) {
      Swal.fire({
        icon: "info",
        title: "No Records",
        text: "No entries found for the selected filters.",
      });
      return;
    }

    // 🔥 Ask user what format they want
    const format = await askDownloadFormat();
    if (!format) return; // user cancelled

    const title =
      paymentTypeMap[String(selectedPaymentType)] || "Payment Entries";
    const baseFilename = title.toLowerCase().replace(/\s+/g, "_");

    // ✅ Download ONLY selected format
    if (format === "excel") {
      await downloadExcel(rows, baseFilename);
    } else if (format === "pdf") {
      await downloadPDF(rows, title, baseFilename);
    }

    Swal.fire({
      icon: "success",
      title: "Download Complete",
      text: `${format.toUpperCase()} file downloaded successfully.`,
    });

    setStartDate("");
    setEndDate("");
    setSelectedPaymentType("");
    setSelectedPayment("");

    handleCloseDown();
  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";
    if (error.response?.data?.message) {
      errorMessage =
        typeof error.response.data.message === "string"
          ? error.response.data.message
          : JSON.stringify(error.response.data.message);
    }

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: errorMessage,
    });
  } finally {
    setIsSaving(false);
    setIsSaving1(false);
  }
};

const  isPayable  = selectedPaymentType == 7



  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      

      <div className={classes.Container}>
        {/* <div className={classes.actions}>
                    <button className={`${classes.btnss} ${classes.greens}`}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={classes.btns}>Product & Services </button>

                </div> */}

                <Modal show={showDown} onHide={handleCloseDown} centered>
      <Modal.Header closeButton>
        <Modal.Title>Download Bulk Entries</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
        <div className={classes.Group33}>
        <Form.Label>Payment Type</Form.Label>
        <select
      // style={{width: 350}}
          value={selectedPaymentType}
          
          onChange={(e) => {
                  setSelectedPaymentType(e.target.value);
          }}
        >
         <option value="">Select Type</option>
    <option value="1">Supplier Payment</option>
    <option value="2">General Payment</option>
    <option value="3">Loan Disbursement</option>
    <option value="4">Statutory Payment</option>
    <option value="5">Cash Advances</option>
    <option value="6">Purchase of fixed asset</option> 
        </select>
      </div>

      <div className={classes.Group33}>
        <label className="mt-4">Mode of Payment</label>
        <select
      // style={{width: 350}}
          value={selectedPayment}
          // disabled
          onChange={(e) => {
            setSelectedPayment(e.target.value); // keep it as a string
          }}
        >
          <option value="">Select Type</option>
          <option value="cheque">Cheque</option>
          <option value="bank transfer">Bank Transfer</option>
          
        </select>
      </div>

          {/* Start Date */}
          <Form.Group className="mb-3 mt-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </Form.Group>

          {/* End Date */}
          <Form.Group className="mb-3 mt-2">
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseDown}>
          Cancel
        </Button>
        <Button 
        // type="submit"
        className={classes.submitBtn}
        onClick={createDownload}
        >
           {isSaving ? (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <Spinner animation="border" size="sm" /> Downloading Entries...
                      </span>
                    ) : (
                      "Download Entries"
                    )}
        </Button>
      </Modal.Footer>
    </Modal>

                <Modal show={showEdit} onHide={handleCloseEdit} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{fontSize: "16px"}}>View Payment Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
  {payLoad ? (
    <p>Loading payment details...</p>
  ) : selectedPayment && selectedPayment.length > 0 ? (
    <table className={classes.table} style={{ border: "none", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th>Trans. Ref</th>
          <th>Beneficiary Name</th>
          <th>Description</th>
          <th>Transaction Date</th>
          <th style={{ textAlign: "right" }}>Amount Paid</th>
        </tr>
      </thead>
      <tbody >
        {/* {selectedPayment.map((item, index) => (
          <tr key={index}>
            <td>{item.uuid}</td>
            <td style={{paddingLeft: "40px"}}>{item.particular}</td>
            <td style={{paddingLeft: "20px"}}>{item.description}</td>
            <td style={{paddingLeft: "30px"}}>
              {item.transaction_date
                ? item.transaction_date.split("T")
                : ""}
            </td>
          
            <td style={{ textAlign: "right" }}>
              {Number(item.amount).toLocaleString()}
            </td>
          </tr>
        ))} */}
      </tbody>
    </table>
  ) : (
    <p>No payment data found.</p>
  )}
</Modal.Body>


        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEdit}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={() => console.log("Save changes")}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>
          


        {/* <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div> */}

   

        <header className={classes.Header}>
          <h2 className={classes.Title}>Payments - Bulk Entries</h2>
          <h1 className={classes.Titles}>
            Manage your bulk payments.
          </h1>
        </header>

          <Row>
            <Col md={3}>
              <div className={classes.thrdkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Total Payment</p>
                  <p className={classes.kdptg1}>
                  {/* ₦8,400,000.00 */} 
                ₦0.00
                  </p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This month</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frtkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Completed</p>
                  <p className={classes.kdptg2}>
                  ₦0.00
                  {/* ₦4,950,000.00 */}
                  </p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Completed payments</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.fiftkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Overdue</p>
                  <p className={classes.kdptg3}>
                  {/* ₦3,200,000.00 */}
                 ₦0.00
                  </p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Past due dates</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frstkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Pending</p>
                  <p className={classes.kdptg4}>
                  {/* ₦3,200,000.00 */}
                  ₦0.00
                  </p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Total invoices</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
          <button className={classes.downBtn}  onClick={handleShowDown}>
          <img src={upload} alt="upload" /> 
          Download Payment Entries</button>
          {/* <button className={classes.downBtn}  onClick={createDownload}>
         
          {isSaving1 ? (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <Spinner animation="border" size="sm" /> Downloading All Entries...
                      </span>
                    ) : (
                      <>
                      <img src={upload} alt="upload" /> 
                      Download All
                      </>
                    )}</button> */}
            {/* <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search Payments" />
            </div> */}
            {/* <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div> */}

            {/* <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div> */}
          </div>
          <div className={classes.actionsLeft}>
            <button className={classes.downBtn}  onClick={openReferenceModal}>
              <img src={upload} alt="upload" /> Retrieve Payments</button>
            {/* <button className={classes.btnss} onClick={handleShow1}> + Upload Payments</button> */}
            <button className={classes.btnss} onClick={handleOpenPayModal}> + New Payments</button>
          </div>
        </div>

        <div className={classes.invoicecont}>
         
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr style={{ fontSize: "12px" }}>
                  <th style={{}}>S/N</th>
                  <th style={{}}>Reference No</th>
                  <th style={{}}>Narration</th>
                  {/* <th style={{}}>Description</th> */}
                  <th style={{}}>Mode of Payment</th>
                  <th style={{}}>Transaction Date</th>
                  {/* <th style={{}}>Currency</th> */}
                  <th style={{}}>Amount</th>
                  {/* <th style={{}}>Base Eqiv</th> */}
                  {/* <th style={{}}>Bank Lodged</th> */}
                  {/* <th>Supplier Name</th> */}
                  {/* <th style={{width: "8%"}}>Status</th> */}
                  {/* <th>Post Date</th> */}
                  <th style={{}}>Action</th>
                </tr>
              </thead>
              <tbody>

                {paymentLoading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(7)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : tableData.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>
                        No payment found.
                      </td>
                    </tr>
                  ) : (
                    tableData.map((item, index) => (
                      <tr key={item.id} style={{ fontSize: "12px", height: 10 }}>
                        <td>{index + 1}</td>
                        <td>{item.receipt_number}</td>
                        <td>{item.particular}</td>
                        {/* <td style={{}}>{item.description}</td> */}
                        <td style={{}}>{item.payment_mode === "2" ? "Cheque" : "Bank Transfer"}</td>
                        <td style={{}}>{item.transaction_date ? item.transaction_date.split("T")[0] : ""}</td>
                        {/* <td>{item?.currency?.code}</td> */}
                        {/* <td>{item.transaction_date}</td> */}
                        {/* <td className={statusClass(item.status || "Pending")}>{item.status || "Pending"}</td> */}
                        <td style={{ textAlign: "right" }}>{parseFloat(item.total_amount).toLocaleString('en-US', {
                    minimumIntegerDigits: 1,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</td>
                        {/* <td style={{ textAlign: "right" }}>{parseFloat(item.amount).toLocaleString('en-US', {
                    minimumIntegerDigits: 1,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</td> */}
                  {/* <td>{item.bank_lodged?.gl_name}</td> */}
                        {/* <td className={statusClass(Number(item.balance) === 0 ? "Success" : Number(item.paid) > 0 ? "Pending" : "Pending")}>
                          {Number(item.balance) === 0 ? "Paid" : Number(item.paid) > 0 ? "Partially Paid" : "Pending"}
                        </td> */}
                       <td
  style={{
    textAlign: "left",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "left",
  }}
>
  <div className={classes.actions}>
    {item.payment_mode !== "2" && (
      <>
        <Printer
          size={16}
          className={classes.printIcon}
          onClick={() => handlePrint(item.receipt_number)}
          style={{ cursor: "pointer" }}
        />

        {/* <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip-print-${item.receipt_number}`}>
              Print with description
            </Tooltip>
          }
        >
          <FcPrint
            size={16}
            color="red"
            className={classes.printIcon}
            onClick={() => handlePrints(item.receipt_number)}
            style={{ cursor: "pointer" }}
          />
        </OverlayTrigger> */}
      </>
    )}
  </div>

  <div className={classes.actions} style={{ marginLeft: 10 }}>
    <Eye
      size={16}
      className={classes.editIcon}
      onClick={() => handleEyeReference(item, true)}
      style={{ cursor: "pointer" }}
    />
  </div>
</td>

                      </tr>
                    ))
                  )}
              </tbody>
            </table>


        

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button                   
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >Previous</button>
              {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return(
                <button className={classes.active}  key={page + 1}
                style={{
                  color: page + 1 === currentPage ? '#ffffff' : '#000',
                  backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                  cursor: "pointer"
                }}
                onClick={() => setCurrentPage(page + 1)}
              > {page + 1}
              </button>
                    );
                  }
                  return null;
                })}
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >Next
              </button>
              <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
            </div>
          </div>


        </div>
      </div>
      <Modal show={showPay} onHide={handleClosePay} size="xl">
           
            <div className={classes.modalContent}>
              <h3 className={classes.title}>Payment - Bulk Entries</h3>
              <div className={classes.topRow}>
               
                <div className={classes.Group}>
        <label>Payment type</label>
        <select
      style={{width: 350}}
          value={selectedPaymentType}
          
          onChange={(e) => {
          setRows([
    {
      beneficiaryId: "",
      debitAccount: "",
      outstandingAmount: "",
      accountId: "",
      amountToPay: "",
      description: "",
      accountOptions: [], 
    },
  ])
                  setSelectedPaymentType(e.target.value);
          }}
        >
         <option value="">Select Type</option>
    <option value="1">Supplier Payment</option>
    <option value="2">General Payment</option>
    <option value="3">Loan Disbursement</option>
    <option value="4">Statutory Payment</option>
    <option value="5">Cash Advances</option>
    <option value="6">Purchase of fixed asset</option>
    <option value="7">Payment from payables</option>
          
        </select>
      </div>
{/* {selectedPaymentType === "2" && ( */}
       <div className={classes.Group}>
                  <label>Loan Type</label>
                  <Select
        // value={selectedCurrency}
        onChange={(selectedOption) => handleLoanChanges(selectedOption)}
        options={loanOptions}
      isDisabled={selectedPaymentType !== "3"}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base) => ({
            ...base,
            minHeight: "35px",
            height: "35px",
            // width: "100%",
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",           // 🔧 FIXED prevent multi-line wrap
            overflow: "hidden",           // 🔧 FIXED keep text inside container
            textOverflow: "ellipsis",     // 🔧 FIXED truncate long text gracefully
            whiteSpace: "nowrap",  
          }),
          indicatorsContainer: (base) => ({
            ...base,
            height: "30px",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          })
        }}
      />
      
                </div>
{/* )} */}
                
      <div />
      <div  className={classes.Group}>
        <label>Journal Reference</label>
        <div className={classes.refContainer}>
           {loadingRef ? (
                        <div className={classes.spinnerWrapper}>
                          <Spinner animation="border" size="sm" />
                        </div>
                      ) : (
                        <input
                                     type="text"
                                     value={journalReference}
                                     disabled
                                     style={{width: 300}}
                                    //  onChange={(e) => setJournalReference(e.target.value)}
                                     required
                                    
                                   />
                                    )}
        </div>
        
      </div>
      
      
               
               
              </div>
              <div style={{marginTop: 10}}/>
              <div className={classes.topRow}>
               <div className={classes.Group}>
        <label>Mode of Payment</label>
        <select
      style={{width: 350}}
          value={selectedPayment}
          
          onChange={(e) => {
            setSelectedPayment(e.target.value); // keep it as a string
          }}
        >
          <option value="">Select Type</option>
          <option value="cheque">Cheque</option>
          <option value="bank transfer">Bank Transfer</option>
          
        </select>
      </div>
                <div className={classes.Group}>
                  <label>Transaction Date</label>
                  <input
                    type="date"
                    value={transactionDate}
                    onChange={(e) => setTransactionDate(e.target.value)}
                    required
                    style={{width: 370}}
                  />
                </div>
      
                {/* ✅ Currency dropdown unchanged */}
                <div className={classes.Group}>
                  <label>Bank</label>
                  <Select
        // value={selectedCurrency}
        onChange={(selectedOption) => handleBankChanges(selectedOption)}
        options={banks}
      
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base) => ({
            ...base,
            minHeight: "35px",
            height: "35px",
            width: "100%",
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",           // 🔧 FIXED prevent multi-line wrap
            overflow: "hidden",           // 🔧 FIXED keep text inside container
            textOverflow: "ellipsis",     // 🔧 FIXED truncate long text gracefully
            whiteSpace: "nowrap",  
          }),
          indicatorsContainer: (base) => ({
            ...base,
            height: "30px",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          })
        }}
      />
      
                </div>
              </div>
      
              <h3 className={classes.titles}>Payment Breakdown</h3>
              <table className={classes.table}>
                <thead style={{backgroundColor: "#174384"}}>
                  <tr style={{color: '#fff'}}>
                    <th>#</th>
                    <th>Beneficiary</th>
                    {isPayable && <th>Outstanding Amount</th>}
                    <th>Beneficary Account</th>
                   {!isPayable &&  <th>Debit Account</th>}
                    <th>Description</th>
                    <th>Amount to Pay</th>
                    <th></th>
                  </tr>
                </thead>
               <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
      
                  {/* Beneficiary Column - React Select */}
                 <td >
                  {
                    isPayable  ?   <Select
                            value={beneficiaryOptionss.find(opt => opt.value === row.beneficiaryId) || null}
                            isDisabled={row.locked}
                            onChange={(option) => handleBeneficiaryChanges(index, option)}
                            options={beneficiaryOptionss}
                            placeholder="Select Beneficiary"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({
                                ...base,
                                minHeight: "35px",
                                fontSize: "12px",
                                borderColor: "#ccc",
                                "&:hover": { borderColor: "#999" },
                              }),
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "12px",
                                color: "#999",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                fontSize: "12px",
                              }),
                          
                              // 🔥 Added: reduce dropdown option font size
                              option: (base, state) => ({
                                ...base,
                                fontSize: "13px",
                                padding: "6px 10px",
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "13px",
                              }),
                            }}
                          />
                         
                                      :       <Select
  value={beneficiaryOptions.find(opt => opt.value === row.beneficiaryId) || null}
  onChange={(option) => {
    if (option.value === "__add_new__") {
      setShow(true); // open the modal
      return;
    }
    handleBeneficiaryChange(index, option);
    setCurrentBeneficiaryId(row.beneficiaryId);
  }}
  onMenuOpen={() => {
  loadBeneficiaryData();   // 🔥 refresh beneficiaries when dropdown opens
}}
  options={beneficiaryDropdownOptions}
  isDisabled={row.locked}
  placeholder="Select Beneficiary"
  menuPortalTarget={document.body}
  formatOptionLabel={(data) => {
    if (data.isAddNew) {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: 'pointer' }}>
          <span style={{ fontSize: 15 }}>➕</span>
          <strong>Add New Beneficiary</strong>
        </div>
      );
    }
    return data.label;
  }}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      fontSize: "13px",
      padding: "6px 10px",
      backgroundColor: state.data.isAddNew ? "#e7f3ff" : base.backgroundColor,
      color: state.data.isAddNew ? "#004a99" : base.color,
      fontWeight: state.data.isAddNew ? "600" : "normal"
    }),
  }}
/>
                  }
             

     
                  </td>
                  {
                    isPayable  &&    <CurrencyInput
                                          name={`outstanding-${index}`}
                                          value={row.outstandingAmount}
                                          disabled
                                          className={`form-control ${classes.currencyInput}`}
                                          style={{
                                            textAlign: "right",
                                            backgroundColor: "#f5f5f5",
                                            cursor: "not-allowed",
                                            border: "1px solid #ddd",
                                            height: "36px",
                                            fontSize: "12px",
                                            marginTop:10
                                          }}
                                          decimalsLimit={2}
                                        />
                  }
                   <td>
                    {
                      isPayable ?   <Select
                                         value={(row.accountOptions || []).find(a => a.value === row.accountId) || null}
                                         isDisabled={row.locked}
                              onChange={(selectedOption) => handleAccountChange(index, selectedOption)}
                              options={row.accountOptions}
                                            placeholder="Select Account"
                                            menuPortalTarget={document.body}
                                            styles={{
                                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                              control: (base) => ({
                                                ...base,
                                                minHeight: "35px",
                                                fontSize: "12px",
                                                borderColor: "#ccc",
                                                "&:hover": { borderColor: "#999" },
                                              }),
                                              placeholder: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                                color: "#999",
                                              }),
                                              option: (base, state) => ({
                                  ...base,
                                  fontSize: "13px",
                                  padding: "6px 10px",
                                }),
                                              singleValue: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                              }),
                                            }}
                                          /> :              
                                             <Select
  value={(row.accountOptions || []).find(a => a.value === row.accountId) || null}
  
  onChange={(selectedOption) => {
    if (selectedOption.value === "__add_beneficiary_account__") {
      setCurrentBeneficiaryId(row.beneficiaryId); // optional, if needed
      setShowBeneficiaryAccModal(true);
      return;
    }
    handleAccountChange(index, selectedOption);
  }}

  options={
  selectedPaymentType === "3"
    ? [
        {
          label: "➕ Add Beneficiary Account",
          value: "__add_beneficiary_account__",
          isAddNew: true,
        },
        ...((row.accountOptions ?? []))  // ✅ SAFE SPREAD
      ]
    : (row.accountOptions ?? [])         // ✅ SAFE fallback
}


  isDisabled={row.locked}
  placeholder="Select Account"
  menuPortalTarget={document.body}

  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      padding: "6px 10px",
      fontSize: "13px",
      backgroundColor: state.data.isAddNew ? "#e7f3ff" : base.backgroundColor,
      color: state.data.isAddNew ? "#004a99" : base.color,
      fontWeight: state.data.isAddNew ? "600" : "normal",
      cursor: "pointer"
    })
  }}
/>
                    }
  


                  </td>
        { !isPayable &&       <td>
  {/* {selectedPaymentType === "3" ? (
    // ⭐ SHOW LOAN ACCOUNT NAME (READ-ONLY)
    <span style={{ fontSize: "12px" }}>
      {loanOptions?.find(opt => opt.value === row.debitAccount)?.accountName || "No Loan Account"}
    </span>
  ) : ( */}
    {/* // ⭐ SHOW NORMAL SELECT WHEN NOT TYPE 3 */}
    <Select
      value={formattedList.find(opt => opt.value === row.debitAccount) || null}
      onChange={(option) => handleExpensesAccountChange(index, option)}
      options={formattedList}
      disabled={row.locked}
isDisabled={row.locked}
      placeholder="Select Debit Account"
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        control: (base) => ({
          ...base,
          minHeight: "35px",
          fontSize: "12px",
          borderColor: "#ccc",
          "&:hover": { borderColor: "#999" },
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: "12px",
          color: "#999",
        }),
        option: (base) => ({
          ...base,
          fontSize: "13px",
          padding: "6px 10px",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "12px",
        }),
        menu: (base) => ({
          ...base,
          fontSize: "13px",
        }),
      }}
    />
  {/* )} */}
</td>}
<td>
  <textarea
    value={row.description || ""}
    onChange={(e) => handleDescriptionChange(index, e.target.value)}
    disabled={row.locked}
    style={{
      width: "160px",
      height: "35px",
      fontSize: "12px",
      padding: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      resize: "none"
    }}
    placeholder="Enter description"
  />
</td>

      {/* <td></td> */}
                  {/* Outstanding Amount Column - Disabled Input */}
                  {/* <td>
                    <CurrencyInput
                      name={`outstanding-${index}`}
                      value={row.outstandingAmount}
                      disabled
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        backgroundColor: "#f5f5f5",
                        cursor: "not-allowed",
                        border: "1px solid #ddd",
                        height: "35px",
                        fontSize: "12px",
                      }}
                      decimalsLimit={2}
                    />
                  </td> */}
      
                  {/* Account Column - React Select */}
                 
      
                  {/* Amount to Pay Column - Currency Input */}
                  <td>
                    <CurrencyInput
                      name={`amount-${index}`}
                      value={row.amountToPay}
                      disabled={row.locked}
isDisabled={row.locked}
                      onValueChange={(value) => handleAmountChange(index, value)}
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        border: "1px solid #ccc",
                        height: "35px",
                        fontSize: "12px",
                        paddingRight: "10px",
                      }}
                      placeholder="0.00"
                      decimalsLimit={2}
                      allowNegativeValue={false}
                    />
                  </td>
      
                  <td>
                     {row.documentUrl && (
          <span
            onClick={() => handleOpenDoc(row.documentUrl)}
            style={{
              cursor: "pointer",
              fontSize: "18px",
              color: "#174384"
            }}
            title="View Document"
          >
           <BsFillFileEarmarkPdfFill size={20} color="#0d0836ff"/> 
          </span>
        )}
        {!row.locked && (
        <MdDeleteForever onClick={() => removeRow(index)} size={20} color="red" style={{cursor: 'pointer'}}/>)}
                    {/* <button
                      onClick={() => removeRow(index)}
                      className={classes.removeBtn}
                      style={{ marginLeft: "10px" }}
                    >
                      Remove
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
              </table>
      
              <div className={classes.actionRow}>
                 <button className={classes.addLineBtn} onClick={addLine}>
              {lineLoading ?  'Saving your row....' : '+ Add Line'}
            </button>
              </div>
      
       <h3 className={classes.titles}>Payment Review</h3>
              <table className={classes.table}>
                <thead style={{backgroundColor: "#174384"}}>
                  <tr style={{color: '#fff'}}>
                    <th>#</th>
                    <th>Beneficiary</th>
                    {/* <th>Outstanding Amount</th>  ✅ new column */}
                    <th>Beneficary Account</th>
                    <th>Debit Account</th>
                    <th>Description</th>
                    <th>Amount to Pay</th>
                    <th></th>
                  </tr>
                </thead>
               <tbody>
              {viewData.map((row, index) => (
                <tr key={index} style={{textAlign: 'center'}}>
                  <td>{index + 1}</td>
      
                  {/* Beneficiary Column - React Select */}
                 <td >
                  {row.beneficiary?.name || row.customer?.name} 
                  </td>
                   <td>
                    {row.beneficiary_account?.bank_name || row.customer_bank?.bank_name} - {row.beneficiary_account?.bank_account || row.customer_bank?.account_number}
                  </td>
                 <td >
                    {row.account?.gl_name} 
     
                  </td>
                 <td >
                    {row.payment_description} 
     
                  </td>
      {/* <td></td> */}
                  {/* Outstanding Amount Column - Disabled Input */}
                  {/* <td>
                    <CurrencyInput
                      name={`outstanding-${index}`}
                      value={row.outstandingAmount}
                      disabled
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        backgroundColor: "#f5f5f5",
                        cursor: "not-allowed",
                        border: "1px solid #ddd",
                        height: "35px",
                        fontSize: "12px",
                      }}
                      decimalsLimit={2}
                    />
                  </td> */}
      
                  {/* Account Column - React Select */}
                 
      
                  {/* Amount to Pay Column - Currency Input */}
                  <td style={{textAlign: 'right'}}>
    {Number(row.amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}
</td>
      
                  <td>
                     
        <MdDeleteForever  onClick={() => handleDeleteReviewRow(index, row)} size={20} color="red" style={{cursor: 'pointer'}}/>
                    {/* <button
                      onClick={() => removeRow(index)}
                      className={classes.removeBtn}
                      style={{ marginLeft: "10px" }}
                    >
                      Remove
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
              </table>
              <div className={classes.totalRow}>
                <div className={classes.totalBox}>
                  <span style={{whiteSpace: "nowrap"}} >Total Amount</span>
                 <strong style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
        {Number(totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </strong>
                </div>
              </div>
      
              {/* <form  */}
              {/* // onSubmit={handleSubmit}
              > */}
                <div className={classes.footerButtons}>
                  
      
                  {/* <button type="button" className={classes.printBtn} onClick={handlePrinter}>
                    Print
                  </button> */}
      
                  <button
                    type="submit"
                    className={classes.submitBtn}
                    // disabled={isSaving || !isBalanced}
                    onClick={handleFetchPayments}
                  >
                   
                    {isSaving ? (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <Spinner animation="border" size="sm" /> Saving...
                      </span>
                    ) : (
                      "Save Payments"
                    )}
                  </button>
                </div>
              {/* </form> */}
      
              <button className={classes.closeBtn} onClick={handleClosePay}>
                ×
              </button>
            </div>
      
            {/* <Modal.Footer>
              <Button variant="secondary" onClick={handleClosePay}>Reset</Button>
              <Button style={{ backgroundColor: '#092147', borderColor: '#092147' }} onClick={() => console.log({ paymentType, paymentTo, date, currency, description, modeOfPayment, debitAccount, totalAmount, loanAccount, reference, lines })}>Save Receipt</Button>
            </Modal.Footer> */}
          </Modal>

      <Modal show={showRetrievePay} onHide={handleCloseRetrievePay} size="xl">
           
            <div className={classes.modalContent}>
              <h3 className={classes.title}>Retrieve Payment - Bulk Entries</h3>
              <div className={classes.topRow}>
               
                <div className={classes.Group}>
        <label>Payment type</label>
        
        <select
      style={{width: 350}}
          value={selectedPaymentType}
          // disabled
          onChange={(e) => {
             setRows([
    {
      beneficiaryId: "",
      debitAccount: "",
      outstandingAmount: "",
      accountId: "",
      amountToPay: "",
      description: "",
      accountOptions: [], 
    },
  ])
                  setSelectedPaymentType(e.target.value);
          }}
        >
         <option value="">Select Type</option>
    <option value="1">Supplier Payment</option>
    <option value="2">General Payment</option>
    <option value="3">Loan Disbursement</option>
    <option value="4">Statutory Payment</option>
    <option value="5">Cash Advances</option>
    <option value="6">Purchase of fixed asset</option>
     <option value="7">Payment from payables</option>
          
        </select>
      </div>
{/* {selectedPaymentType === "2" && ( */}
       <div className={classes.Group}>
                  <label>Loan Type</label>
                 <Select
        // value={selectedCurrency}
        onChange={(selectedOption) => handleLoanChanges(selectedOption)}
        options={loanOptions}
      isDisabled={selectedPaymentType !== "3"}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base) => ({
            ...base,
            minHeight: "35px",
            height: "35px",
            // width: "100%",
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",           // 🔧 FIXED prevent multi-line wrap
            overflow: "hidden",           // 🔧 FIXED keep text inside container
            textOverflow: "ellipsis",     // 🔧 FIXED truncate long text gracefully
            whiteSpace: "nowrap",  
          }),
          indicatorsContainer: (base) => ({
            ...base,
            height: "30px",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          })
        }}
      />

      
                </div>
{/* )} */}
                
      <div />
      <div  className={classes.Group}>
        <label>Journal Reference</label>
        <div className={classes.refContainer}>
           {/* {loadingRef ? (
                        <div className={classes.spinnerWrapper}>
                          <Spinner animation="border" size="sm" />
                        </div>
                      ) : ( */}
                        <input
                                     type="text"
                                     value={journalReference}
                                     disabled
                                     style={{width: 300}}
                                    //  onChange={(e) => setJournalReference(e.target.value)}
                                     required
                                    
                                   />
                                    {/* )} */}
        </div>
        
      </div>
      
      
               
               
              </div>
              <div style={{marginTop: 10}}/>
              <div className={classes.topRow}>
               <div className={classes.Group}>
        <label>Mode of Payment</label>
        <select
      style={{width: 350}}
          value={selectedPayment}
          // disabled
          onChange={(e) => {
            setSelectedPayment(e.target.value); // keep it as a string
          }}
        >
          <option value="">Select Type</option>
          <option value="cheque">Cheque</option>
          <option value="bank transfer">Bank Transfer</option>
          
        </select>
      </div>
                <div className={classes.Group}>
                  <label>Transaction Date</label>
                  <input
                    type="date"
                    value={transactionDate}
                    // disabled
                    onChange={(e) => setTransactionDate(e.target.value)}
                    required
                    style={{width: 370}}
                  />
                </div>
      
                {/* ✅ Currency dropdown unchanged */}
                <div className={classes.Group}>
                  <label>Bank</label>
                  <Select
  // value={
  //   viewData[0]?.bank_id
  //     ? banks.find(b => b.value === viewData[0].bank_id) || null
  //     : null
  // }
  onChange={(selectedOption) => handleBankChanges(selectedOption)}
  options={banks}
  // isDisabled={!!viewData.length}  // disable if reference loaded
  menuPortalTarget={document.body}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: "35px",
      height: "35px",
      width: "100%",
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "30px",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  }}
/>

      
                </div>
              </div>
      
              <h3 className={classes.titles}>Payment Breakdown</h3>
              <table className={classes.table}>
                <thead style={{backgroundColor: "#174384"}}>
                  <tr style={{color: '#fff'}}>
                    <th>#</th>
                    <th>Beneficiary</th>
                    {isPayable && <th>Outstanding Amount</th>}
                    <th>Beneficary Account</th>
                    {!isPayable &&  <th>Debit Account</th>}
                    <th>Description</th>
                    <th>Amount to Pay</th>
                    <th></th>
                  </tr>
                </thead>
               <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
      
                  {/* Beneficiary Column - React Select */}
                 <td >
                  {
                    isPayable  ?  
                    <Select
                            value={beneficiaryOptionss.find(opt => opt.value === row.beneficiaryId) || null}
                            isDisabled={row.locked}
                            onChange={(option) => handleBeneficiaryChanges(index, option)}
                            options={beneficiaryOptionss}
                            placeholder="Select Beneficiary"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({
                                ...base,
                                minHeight: "35px",
                                fontSize: "12px",
                                borderColor: "#ccc",
                                "&:hover": { borderColor: "#999" },
                              }),
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "12px",
                                color: "#999",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                fontSize: "12px",
                              }),
                          
                              // 🔥 Added: reduce dropdown option font size
                              option: (base, state) => ({
                                ...base,
                                fontSize: "13px",
                                padding: "6px 10px",
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "13px",
                              }),
                            }}
                          />
                          :
                     <Select
  value={beneficiaryOptions.find(opt => opt.value === row.beneficiaryId) || null}
  onChange={(option) => {
    if (option.value === "__add_new__") {
      setShow(true); // open the modal
      return;
    }
    handleBeneficiaryChange(index, option);
  }}
  onMenuOpen={() => {
  loadBeneficiaryData();   // 🔥 refresh beneficiaries when dropdown opens
}}
  options={beneficiaryDropdownOptions}
  isDisabled={row.locked}
  placeholder="Select Beneficiary"
  menuPortalTarget={document.body}
  formatOptionLabel={(data) => {
    if (data.isAddNew) {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: 'pointer' }}>
          <span style={{ fontSize: 15 }}>➕</span>
          <strong>Add New Beneficiary</strong>
        </div>
      );
    }
    return data.label;
  }}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      fontSize: "13px",
      padding: "6px 10px",
      backgroundColor: state.data.isAddNew ? "#e7f3ff" : base.backgroundColor,
      color: state.data.isAddNew ? "#004a99" : base.color,
      fontWeight: state.data.isAddNew ? "600" : "normal"
    }),
  }}
/>
}
     
                  </td>
                   {
                    isPayable  &&    <CurrencyInput
                                          name={`outstanding-${index}`}
                                          value={row.outstandingAmount}
                                          disabled
                                          className={`form-control ${classes.currencyInput}`}
                                          style={{
                                            textAlign: "right",
                                            backgroundColor: "#f5f5f5",
                                            cursor: "not-allowed",
                                            border: "1px solid #ddd",
                                            height: "36px",
                                            fontSize: "12px",
                                            marginTop:10
                                          }}
                                          decimalsLimit={2}
                                        />
                  }
                   <td>
                    {
                      isPayable ?   <Select
                                         value={(row.accountOptions || []).find(a => a.value === row.accountId) || null}
                                         isDisabled={row.locked}
                              onChange={(selectedOption) => handleAccountChange(index, selectedOption)}
                              options={row.accountOptions}
                                            placeholder="Select Account"
                                            menuPortalTarget={document.body}
                                            styles={{
                                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                              control: (base) => ({
                                                ...base,
                                                minHeight: "35px",
                                                fontSize: "12px",
                                                borderColor: "#ccc",
                                                "&:hover": { borderColor: "#999" },
                                              }),
                                              placeholder: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                                color: "#999",
                                              }),
                                              option: (base, state) => ({
                                  ...base,
                                  fontSize: "13px",
                                  padding: "6px 10px",
                                }),
                                              singleValue: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                              }),
                                            }}
                                          /> :              
                    <Select
  value={(row.accountOptions || []).find(a => a.value === row.accountId) || null}
  
  onChange={(selectedOption) => {
    if (selectedOption.value === "__add_beneficiary_account__") {
      setCurrentBeneficiaryId(row.beneficiaryId); // optional, if needed
      setShowBeneficiaryAccModal(true);
      return;
    }
    handleAccountChange(index, selectedOption);
  }}

  options={
  selectedPaymentType === "3"
    ? [
        {
          label: "➕ Add Beneficiary Account",
          value: "__add_beneficiary_account__",
          isAddNew: true,
        },
        ...((row.accountOptions ?? []))  // ✅ SAFE SPREAD
      ]
    : (row.accountOptions ?? [])         // ✅ SAFE fallback
}


  isDisabled={row.locked}
  placeholder="Select Account"
  menuPortalTarget={document.body}

  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      padding: "6px 10px",
      fontSize: "13px",
      backgroundColor: state.data.isAddNew ? "#e7f3ff" : base.backgroundColor,
      color: state.data.isAddNew ? "#004a99" : base.color,
      fontWeight: state.data.isAddNew ? "600" : "normal",
      cursor: "pointer"
    })
  }}
/>
}
                  </td>
          { !isPayable &&         <td>
  <Select
      value={formattedList.find(opt => opt.value === row.debitAccount) || null}
      onChange={(option) => handleExpensesAccountChange(index, option)}
      options={formattedList}
      disabled={row.locked}
isDisabled={row.locked}
      placeholder="Select Debit Account"
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        control: (base) => ({
          ...base,
          minHeight: "35px",
          fontSize: "12px",
          borderColor: "#ccc",
          "&:hover": { borderColor: "#999" },
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: "12px",
          color: "#999",
        }),
        option: (base) => ({
          ...base,
          fontSize: "13px",
          padding: "6px 10px",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "12px",
        }),
        menu: (base) => ({
          ...base,
          fontSize: "13px",
        }),
      }}
    />
</td>}
<td>
  <textarea
    value={row.description || ""}
    onChange={(e) => handleDescriptionChange(index, e.target.value)}
    disabled={row.locked}
    style={{
      width: "160px",
      height: "35px",
      fontSize: "12px",
      padding: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      resize: "none"
    }}
    placeholder="Enter description"
  />
</td>


      {/* <td></td> */}
                  {/* Outstanding Amount Column - Disabled Input */}
                  {/* <td>
                    <CurrencyInput
                      name={`outstanding-${index}`}
                      value={row.outstandingAmount}
                      disabled
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        backgroundColor: "#f5f5f5",
                        cursor: "not-allowed",
                        border: "1px solid #ddd",
                        height: "35px",
                        fontSize: "12px",
                      }}
                      decimalsLimit={2}
                    />
                  </td> */}
      
                  {/* Account Column - React Select */}
                 
      
                  {/* Amount to Pay Column - Currency Input */}
                  <td>
                    <CurrencyInput
                      name={`amount-${index}`}
                      value={row.amountToPay}
                     
isDisabled={row.locked}
                      onValueChange={(value) => handleAmountChange(index, value)}
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        border: "1px solid #ccc",
                        height: "35px",
                        fontSize: "12px",
                        paddingRight: "10px",
                      }}
                      placeholder="0.00"
                      decimalsLimit={2}
                      allowNegativeValue={false}
                    />
                  </td>
      
                  <td>
                     {row.documentUrl && (
          <span
            onClick={() => handleOpenDoc(row.documentUrl)}
            style={{
              cursor: "pointer",
              fontSize: "18px",
              color: "#174384"
            }}
            title="View Document"
          >
           <BsFillFileEarmarkPdfFill size={20} color="#0d0836ff"/> 
          </span>
        )}
        {!row.locked && (
        <MdDeleteForever onClick={() => removeRow(index)} size={20} color="red" style={{cursor: 'pointer'}}/>)}
                    {/* <button
                      onClick={() => removeRow(index)}
                      className={classes.removeBtn}
                      style={{ marginLeft: "10px" }}
                    >
                      Remove
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
              </table>
      
              <div className={classes.actionRow}>
                 <button className={classes.addLineBtn} onClick={addLines}>
              {lineLoading ?  'Saving your row....' : '+ Add Line'}
            </button>
              </div>
      
       <h3 className={classes.titles}>Payment Review</h3>
              <table className={classes.table}>
                <thead style={{backgroundColor: "#174384"}}>
                  <tr style={{color: '#fff'}}>
                    <th>#</th>
                    <th>Beneficiary</th>
                    {/* <th>Outstanding Amount</th>  ✅ new column */}
                    <th>Beneficary Account</th>
                    <th>Debit Account</th>
                    <th>Description</th>
                    <th>Amount to Pay</th>
                    <th></th>
                  </tr>
                </thead>
               <tbody>
              {viewData.map((row, index) => (
                <tr key={index} style={{textAlign: 'center'}}>
                  <td>{index + 1}</td>
      
                  {/* Beneficiary Column - React Select */}
                 <td >
                  {row.beneficiary?.name || row.customer?.name} 
                  </td>
                   <td>
                    {row.beneficiary_account?.bank_name || row.customer_bank?.bank_name} - {row.beneficiary_account?.bank_account || row.customer_bank?.account_number}
                  </td>
                 <td >
                    {row.account?.gl_name} 
     
                  </td>
                 <td >
                    {row.payment_description} 
     
                  </td>
      {/* <td></td> */}
                  {/* Outstanding Amount Column - Disabled Input */}
                  {/* <td>
                    <CurrencyInput
                      name={`outstanding-${index}`}
                      value={row.outstandingAmount}
                      disabled
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        backgroundColor: "#f5f5f5",
                        cursor: "not-allowed",
                        border: "1px solid #ddd",
                        height: "35px",
                        fontSize: "12px",
                      }}
                      decimalsLimit={2}
                    />
                  </td> */}
      
                  {/* Account Column - React Select */}
                 
      
                  {/* Amount to Pay Column - Currency Input */}
                  <td style={{textAlign: 'right'}}>
    {Number(row.amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}
</td>
      
                  <td>
                     
        <MdDeleteForever  onClick={() => handleDeleteReviewRow(index, row)} size={20} color="red" style={{cursor: 'pointer'}}/>
                    {/* <button
                      onClick={() => removeRow(index)}
                      className={classes.removeBtn}
                      style={{ marginLeft: "10px" }}
                    >
                      Remove
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
              </table>
              <div className={classes.totalRow}>
                <div className={classes.totalBox}>
                  <span style={{whiteSpace: "nowrap"}} >Total Amount</span>
                 <strong style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
        {Number(totalAmountRetrieve).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </strong>
                </div>
              </div>
      
              {/* <form  */}
              {/* // onSubmit={handleSubmit}
              > */}
                <div className={classes.footerButtons}>
                  
      
                  {/* <button type="button" className={classes.printBtn} onClick={handlePrinter}>
                    Print
                  </button> */}
      
                  <button
                    type="submit"
                    className={classes.submitBtn}
                    // disabled={isSaving || !isBalanced}
                    onClick={handleFetchPaymentsx}
                  >
                   
                    {isSaving ? (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <Spinner animation="border" size="sm" /> Saving...
                      </span>
                    ) : (
                      "Save Payments"
                    )}
                  </button>
                </div>
              {/* </form> */}
      
              <button className={classes.closeBtn} onClick={handleCloseRetrievePay}>
                ×
              </button>
            </div>
      
            {/* <Modal.Footer>
              <Button variant="secondary" onClick={handleClosePay}>Reset</Button>
              <Button style={{ backgroundColor: '#092147', borderColor: '#092147' }} onClick={() => console.log({ paymentType, paymentTo, date, currency, description, modeOfPayment, debitAccount, totalAmount, loanAccount, reference, lines })}>Save Receipt</Button>
            </Modal.Footer> */}
          </Modal>
            <Modal show={showRetrievePaySaved} onHide={handleCloseRetrievePaySaved} size="xl">
           
            <div className={classes.modalContent}>
              <h3 className={classes.title}>Saved Payment - Bulk Entries</h3>
              <div className={classes.topRow}>
               
                <div className={classes.Group}>
        <label>Payment type</label>
        
        <select
      style={{width: 350}}
          value={selectedPaymentType}
          // disabled
          onChange={(e) => {
             setRows([
    {
      beneficiaryId: "",
      debitAccount: "",
      outstandingAmount: "",
      accountId: "",
      amountToPay: "",
      description: "",
      accountOptions: [], 
    },
  ])
                  setSelectedPaymentType(e.target.value);
          }}
        >
         <option value="">Select Type</option>
    <option value="1">Supplier Payment</option>
    <option value="2">General Payment</option>
    <option value="3">Loan Disbursement</option>
    <option value="4">Statutory Payment</option>
    <option value="5">Cash Advances</option>
    <option value="6">Purchase of fixed asset</option>
    <option value="7">Payment from payables</option>
          
        </select>
      </div>
{/* {selectedPaymentType === "2" && ( */}
       <div className={classes.Group}>
                  <label>Loan Type</label>
                 <Select
        // value={selectedCurrency}
        onChange={(selectedOption) => handleLoanChanges(selectedOption)}
        options={loanOptions}
      isDisabled={selectedPaymentType !== "3"}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base) => ({
            ...base,
            minHeight: "35px",
            height: "35px",
            // width: "100%",
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",           // 🔧 FIXED prevent multi-line wrap
            overflow: "hidden",           // 🔧 FIXED keep text inside container
            textOverflow: "ellipsis",     // 🔧 FIXED truncate long text gracefully
            whiteSpace: "nowrap",  
          }),
          indicatorsContainer: (base) => ({
            ...base,
            height: "30px",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          })
        }}
      />

      
                </div>
{/* )} */}
                
      <div />
      <div  className={classes.Group}>
        <label>Journal Reference</label>
        <div className={classes.refContainer}>
           {loadingRef ? (
                        <div className={classes.spinnerWrapper}>
                          <Spinner animation="border" size="sm" />
                        </div>
                      ) : (
                        <input
                                     type="text"
                                     value={journalReference}
                                     disabled
                                     style={{width: 300}}
                                    //  onChange={(e) => setJournalReference(e.target.value)}
                                     required
                                    
                                   />
                                    )}
        </div>
        
      </div>
      
      
               
               
              </div>
              <div style={{marginTop: 10}}/>
              <div className={classes.topRow}>
               <div className={classes.Group}>
        <label>Mode of Payment</label>
        <select
      style={{width: 350}}
          value={selectedPayment}
          // disabled
          onChange={(e) => {
            setSelectedPayment(e.target.value); // keep it as a string
          }}
        >
          <option value="">Select Type</option>
          <option value="cheque">Cheque</option>
          <option value="bank transfer">Bank Transfer</option>
          
        </select>
      </div>
                <div className={classes.Group}>
                  <label>Transaction Date</label>
                  <input
                    type="date"
                    value={transactionDate}
                    // disabled
                    onChange={(e) => setTransactionDate(e.target.value)}
                    required
                    style={{width: 370}}
                  />
                </div>
      
                {/* ✅ Currency dropdown unchanged */}
                <div className={classes.Group}>
                  <label>Bank</label>
                  <Select
  // value={
  //   viewData[0]?.bank_id
  //     ? banks.find(b => b.value === viewData[0].bank_id) || null
  //     : null
  // }
  onChange={(selectedOption) => handleBankChanges(selectedOption)}
  options={banks}
  // isDisabled={!!viewData.length}  // disable if reference loaded
  menuPortalTarget={document.body}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: "35px",
      height: "35px",
      width: "100%",
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "30px",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  }}
/>

      
                </div>
              </div>
      
              <h3 className={classes.titles}>Payment Breakdown</h3>
              <table className={classes.table}>
                <thead style={{backgroundColor: "#174384"}}>
                  <tr style={{color: '#fff'}}>
                    <th>#</th>
                    <th>Beneficiary</th>
                    {isPayable && <th>Outstanding Amount</th>}
                    <th>Beneficary Account</th>
                    {!isPayable &&  <th>Debit Account</th>}
                    <th>Description</th>
                    <th>Amount to Pay</th>
                    <th></th>
                  </tr>
                </thead>
               <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
      
                  {/* Beneficiary Column - React Select */}
                 <td >
                  {
                    isPayable  ?  
                    <Select
                            value={beneficiaryOptionss.find(opt => opt.value === row.beneficiaryId) || null}
                            isDisabled={row.locked}
                            onChange={(option) => handleBeneficiaryChanges(index, option)}
                            options={beneficiaryOptionss}
                            placeholder="Select Beneficiary"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({
                                ...base,
                                minHeight: "35px",
                                fontSize: "12px",
                                borderColor: "#ccc",
                                "&:hover": { borderColor: "#999" },
                              }),
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "12px",
                                color: "#999",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                fontSize: "12px",
                              }),
                          
                              // 🔥 Added: reduce dropdown option font size
                              option: (base, state) => ({
                                ...base,
                                fontSize: "13px",
                                padding: "6px 10px",
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "13px",
                              }),
                            }}
                          />
                          :
                     <Select
  value={beneficiaryOptions.find(opt => opt.value === row.beneficiaryId) || null}
  onChange={(option) => {
    if (option.value === "__add_new__") {
      setShow(true); 
      return;
    }
    handleBeneficiaryChange(index, option);
  }}
  onMenuOpen={() => {
  loadBeneficiaryData();   // 🔥 refresh beneficiaries when dropdown opens
}}
  options={beneficiaryDropdownOptions}
  isDisabled={row.locked}
  placeholder="Select Beneficiary"
  menuPortalTarget={document.body}
  formatOptionLabel={(data) => {
    if (data.isAddNew) {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: 'pointer' }}>
          <span style={{ fontSize: 15 }}>➕</span>
          <strong>Add New Beneficiary</strong>
        </div>
      );
    }
    return data.label;
  }}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      fontSize: "13px",
      padding: "6px 10px",
      backgroundColor: state.data.isAddNew ? "#e7f3ff" : base.backgroundColor,
      color: state.data.isAddNew ? "#004a99" : base.color,
      fontWeight: state.data.isAddNew ? "600" : "normal"
    }),
  }}
/>
}
                  </td>
                   {
                    isPayable  &&    <CurrencyInput
                                          name={`outstanding-${index}`}
                                          value={row.outstandingAmount}
                                          disabled
                                          className={`form-control ${classes.currencyInput}`}
                                          style={{
                                            textAlign: "right",
                                            backgroundColor: "#f5f5f5",
                                            cursor: "not-allowed",
                                            border: "1px solid #ddd",
                                            height: "36px",
                                            fontSize: "12px",
                                            marginTop:10
                                          }}
                                          decimalsLimit={2}
                                        />
                  }
                   <td>
                    {
                      isPayable ?   <Select
                                         value={(row.accountOptions || []).find(a => a.value === row.accountId) || null}
                                         isDisabled={row.locked}
                              onChange={(selectedOption) => handleAccountChange(index, selectedOption)}
                              options={row.accountOptions}
                                            placeholder="Select Account"
                                            menuPortalTarget={document.body}
                                            styles={{
                                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                              control: (base) => ({
                                                ...base,
                                                minHeight: "35px",
                                                fontSize: "12px",
                                                borderColor: "#ccc",
                                                "&:hover": { borderColor: "#999" },
                                              }),
                                              placeholder: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                                color: "#999",
                                              }),
                                              option: (base, state) => ({
                                  ...base,
                                  fontSize: "13px",
                                  padding: "6px 10px",
                                }),
                                              singleValue: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                              }),
                                            }}
                                          /> :              
                    <Select
  value={(row.accountOptions || []).find(a => a.value === row.accountId) || null}
  
  onChange={(selectedOption) => {
    if (selectedOption.value === "__add_beneficiary_account__") {
      setCurrentBeneficiaryId(row.beneficiaryId); // optional, if needed
      setShowBeneficiaryAccModal(true);
      return;
    }
    handleAccountChange(index, selectedOption);
  }}

  options={
  selectedPaymentType === "3"
    ? [
        {
          label: "➕ Add Beneficiary Account",
          value: "__add_beneficiary_account__",
          isAddNew: true,
        },
        ...((row.accountOptions ?? []))  // ✅ SAFE SPREAD
      ]
    : (row.accountOptions ?? [])         // ✅ SAFE fallback
}


  isDisabled={row.locked}
  placeholder="Select Account"
  menuPortalTarget={document.body}

  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      padding: "6px 10px",
      fontSize: "13px",
      backgroundColor: state.data.isAddNew ? "#e7f3ff" : base.backgroundColor,
      color: state.data.isAddNew ? "#004a99" : base.color,
      fontWeight: state.data.isAddNew ? "600" : "normal",
      cursor: "pointer"
    })
  }}
/>
}
                  </td>
               { !isPayable &&     <td>
  <Select
      value={formattedList.find(opt => opt.value === row.debitAccount) || null}
      onChange={(option) => handleExpensesAccountChange(index, option)}
      options={formattedList}
      disabled={row.locked}
isDisabled={row.locked}
      placeholder="Select Debit Account"
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        control: (base) => ({
          ...base,
          minHeight: "35px",
          fontSize: "12px",
          borderColor: "#ccc",
          "&:hover": { borderColor: "#999" },
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: "12px",
          color: "#999",
        }),
        option: (base) => ({
          ...base,
          fontSize: "13px",
          padding: "6px 10px",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "12px",
        }),
        menu: (base) => ({
          ...base,
          fontSize: "13px",
        }),
      }}
    />
</td>}
<td>
  <textarea
    value={row.description || ""}
    onChange={(e) => handleDescriptionChange(index, e.target.value)}
    disabled={row.locked}
    style={{
      width: "160px",
      height: "35px",
      fontSize: "12px",
      padding: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      resize: "none"
    }}
    placeholder="Enter description"
  />
</td>


      {/* <td></td> */}
                  {/* Outstanding Amount Column - Disabled Input */}
                  {/* <td>
                    <CurrencyInput
                      name={`outstanding-${index}`}
                      value={row.outstandingAmount}
                      disabled
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        backgroundColor: "#f5f5f5",
                        cursor: "not-allowed",
                        border: "1px solid #ddd",
                        height: "35px",
                        fontSize: "12px",
                      }}
                      decimalsLimit={2}
                    />
                  </td> */}
      
                  {/* Account Column - React Select */}
                 
      
                  {/* Amount to Pay Column - Currency Input */}
                  <td>
                    <CurrencyInput
                      name={`amount-${index}`}
                      value={row.amountToPay}
                     
isDisabled={row.locked}
                      onValueChange={(value) => handleAmountChange(index, value)}
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        border: "1px solid #ccc",
                        height: "35px",
                        fontSize: "12px",
                        paddingRight: "10px",
                      }}
                      placeholder="0.00"
                      decimalsLimit={2}
                      allowNegativeValue={false}
                    />
                  </td>
      
                  <td>
                     {row.documentUrl && (
          <span
            onClick={() => handleOpenDoc(row.documentUrl)}
            style={{
              cursor: "pointer",
              fontSize: "18px",
              color: "#174384"
            }}
            title="View Document"
          >
           <BsFillFileEarmarkPdfFill size={20} color="#0d0836ff"/> 
          </span>
        )}
        {!row.locked && (
        <MdDeleteForever onClick={() => removeRow(index)} size={20} color="red" style={{cursor: 'pointer'}}/>)}
                    {/* <button
                      onClick={() => removeRow(index)}
                      className={classes.removeBtn}
                      style={{ marginLeft: "10px" }}
                    >
                      Remove
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
              </table>
      
              <div className={classes.actionRow}>
                 <button className={classes.addLineBtn} onClick={addLinesSaved}>
              {lineLoading ?  'Saving your row....' : '+ Add Line'}
            </button>
              </div>
      
       <h3 className={classes.titles}>Payment Review</h3>
              <table className={classes.table}>
                <thead style={{backgroundColor: "#174384"}}>
                  <tr style={{color: '#fff'}}>
                    <th>#</th>
                    <th>Beneficiary</th>
                    {/* <th>Outstanding Amount</th>  ✅ new column */}
                    <th>Beneficary Account</th>
                    <th>Debit Account</th>
                    <th>Description</th>
                    <th>Amount to Pay</th>
                    <th></th>
                  </tr>
                </thead>
               <tbody>
              {viewData.map((row, index) => (
                <tr key={index} style={{textAlign: 'center'}}>
                  <td>{index + 1}</td>
      
                  {/* Beneficiary Column - React Select */}
                 <td >
                  {row.beneficiary?.name || row.customer?.name || row?.bank?.account_name} 
                  </td>
                   <td>
                    {row.beneficiary_account?.bank_name || row.customer_bank?.bank_name ||  row?.bank?.bank_name} - {row.beneficiary_account?.bank_account || row.customer_bank?.account_number  || row?.bank?.bank_account} 
                  </td>
                 <td >
                    {row.account?.gl_name || row?.credit_account?.gl_name} 
     
                  </td>
                 <td >
                    {row.payment_description} 
     
                  </td>
      {/* <td></td> */}
                  {/* Outstanding Amount Column - Disabled Input */}
                  {/* <td>
                    <CurrencyInput
                      name={`outstanding-${index}`}
                      value={row.outstandingAmount}
                      disabled
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        backgroundColor: "#f5f5f5",
                        cursor: "not-allowed",
                        border: "1px solid #ddd",
                        height: "35px",
                        fontSize: "12px",
                      }}
                      decimalsLimit={2}
                    />
                  </td> */}
      
                  {/* Account Column - React Select */}
                 
      
                  {/* Amount to Pay Column - Currency Input */}
                  <td style={{textAlign: 'right'}}>
    {Number(row.amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}
</td>
      
                  <td>
                     
        <MdDeleteForever  onClick={() => handleDeleteReviewRowSaved(index, row)} size={20} color="red" style={{cursor: 'pointer'}}/>
                    {/* <button
                      onClick={() => removeRow(index)}
                      className={classes.removeBtn}
                      style={{ marginLeft: "10px" }}
                    >
                      Remove
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
              </table>
              <div className={classes.totalRow}>
                <div className={classes.totalBox}>
                  <span style={{whiteSpace: "nowrap"}} >Total Amount</span>
                 <strong style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
        {Number(totalAmountRetrieve).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </strong>
                </div>
              </div>
      
              {/* <form  */}
              {/* // onSubmit={handleSubmit}
              > */}
                <div className={classes.footerButtons}>
                  
      
                  {/* <button type="button" className={classes.printBtn} onClick={handlePrinter}>
                    Print
                  </button> */}
      
                  <button
                    type="submit"
                    className={classes.submitBtn}
                    // disabled={isSaving || !isBalanced}
                    onClick={handleFetchPaymentsx}
                  >
                   
                    {isSaving ? (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <Spinner animation="border" size="sm" /> Saving...
                      </span>
                    ) : (
                      "Save Payments"
                    )}
                  </button>
                </div>
              {/* </form> */}
      
              <button className={classes.closeBtn} onClick={handleCloseRetrievePaySaved}>
                ×
              </button>
            </div>
      
            {/* <Modal.Footer>
              <Button variant="secondary" onClick={handleClosePay}>Reset</Button>
              <Button style={{ backgroundColor: '#092147', borderColor: '#092147' }} onClick={() => console.log({ paymentType, paymentTo, date, currency, description, modeOfPayment, debitAccount, totalAmount, loanAccount, reference, lines })}>Save Receipt</Button>
            </Modal.Footer> */}
          </Modal>
      <Modal show={showDocModal} onHide={handleCloseDoc} size="xl">
        <div style={{ padding: "20px" }}>
          <h4>Supporting Document</h4>
          <button
            onClick={handleCloseDoc}
            style={{
              position: "absolute",
              top: 10,
              right: 20,
              background: "transparent",
              border: "none",
              fontSize: "24px",
              cursor: "pointer"
            }}
          >
            ×
          </button>
      
          
      
          <iframe
            id="docFrame"
            src={currentDocUrl}
            style={{
              width: "100%",
              height: "500px",
              border: "1px solid #ccc",
              borderRadius: "6px"
            }}
          ></iframe>
        </div>
      </Modal>
      <Modal show={show1} onHide={handleClose1} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>New Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ paddingLeft: "25px", paddingRight: "25px" }}>
              <Row style={{ marginBottom: "10px"}}>
                <Col md={6}>
                  <Form.Check
                    label="Supplier/Contractor"
                    name="group1"
                    type="radio"
                    id="supplier"
                    value="supplier"
                    checked={selectedRadio === "supplier"}
                    onChange={handleRadioChange}
                    className={classes.radioGreen}
                  />
                </Col>
                <Col md={6}>
                  <Form.Check
                    label="General Payment"
                    name="group1"
                    type="radio"
                    id="general"
                    value="general"
                    checked={selectedRadio === "general"}
                    onChange={handleRadioChange}
                    className={classes.radioGreen}
                  />
                </Col>
              </Row>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row style={{ marginBottom: "15px" }}>
                 {selectedRadio === "supplier" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Select
                            options={customerOptions}
                            value={selectedCustomer}
                            onChange={setSelectedCustomer}
                            placeholder="Select Supplier"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                      </Col>
                    </Row>
                  </Col>
                 )}
                 {selectedRadio === "general" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Form.Control
                            type="text"
                            value={customerName}
                            onChange={(e) => {
                              const value = e.target.value;
                              const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                              setCustomerName(filteredValue);
                            }}
                            required
                            style={{ width: "100%" }}
                          />
                      </Col>
                    </Row>
                  </Col>
                 )}
                  <Col md={12} style={{ marginBottom: 10 }}>
                        <Row>
                          <Col md={3} style={{ textAlign: "right" }}>
                              <label style={{ width: "100%" }}>Date:</label>
                          </Col>
                          <Col md={9}>
                            <Form.Control
                              type="date"
                              value={paymentDate}
                              onChange={e => setPaymentDate(e.target.value)}
                              required
                              style={{ width: "100%" }}
                            />
                          </Col>
                        </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Description:</label>
                    </Col>
                      <Col md={9}>
                        <Form.Control
                          as="textarea"
                          value={description}
                          rows={1}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                            setDescription(filteredValue);
                          }}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                  </Row>
                  </Col>
                  <Col md={12}>
                      <Row>
                        <Col md={3} style={{ textAlign: "right" }}>
                          <label>Mode:</label>
                        </Col>
                        <Col md={9}>
                          <Select
                            options={paymentMode}
                            value={selectedPaymentMode}
                            onChange={setSelectedPaymentMode}
                            placeholder="Select Payment Mode"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                  </Col>
              </Row>
              <Row>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Currency:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={currencyOptions}
                              value={selectedCurrency}
                              onChange={setSelectedCurrency}
                              placeholder="Currency"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Amount:</label>
                              </Col>
                              <Col md={8}>
                              <CurrencyInput
                                id="total-amount"
                                name="totalAmount"
                                value={amount}
                                decimalsLimit={2}
                                onValueChange={(value) => setAmount(value)}
                                prefix="₦"
                                groupSeparator=","
                                placeholder="Amount"
                                className={`form-control ${classes.optioncss}`}
                              />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Credit:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={bankOptions}
                              value={selectedBank}
                              onChange={setSelectedBank}
                              placeholder="Account"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Debit:</label>
                              </Col>
                              <Col md={8}>
                                <Select
                                  options={bankOptions2}
                                  value={selectedBank2}
                                  onChange={setSelectedBank2}
                                  placeholder="Account"
                                  isClearable
                                  classNamePrefix="react-select"
                                  required
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ paddingLeft: "25px", paddingRight: "25px" }}>
          <Button variant="light" onClick={handleClose1}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment} disabled={addpaymenntLoad} className={classes.btnss}>
              {addpaymenntLoad ? (
                <>
                  <Spinner size="sm" />
                  <span style={{ marginLeft: "5px" }}>
                    Processing, Please wait...
                  </span>
                </>
              ) : (
                "Save Payment"
              )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>New Supplier's Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row style={{ marginBottom: "15px" }}>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Select
                            options={invoiceOptions}
                            value={selectedInvoice}
                            onChange={(option) => {
                              setSelectedInvoice(option);
                              setAmount(option?.balance || "");
                            }}
                            // onChange={setSelectedInvoice}
                            placeholder="Select Supplier"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                          <label style={{ width: "100%" }}>Date:</label>
                      </Col>
                      <Col md={9}>
                        <Form.Control
                          type="date"
                          value={paymentDate}
                          onChange={e => setPaymentDate(e.target.value)}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Description:</label>
                    </Col>
                      <Col md={9}>
                        <Form.Control
                          as="textarea"
                          value={description}
                          rows={1}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                            setDescription(filteredValue);
                          }}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                  </Row>
                  </Col>
                  <Col md={12}>
                      <Row>
                        <Col md={3} style={{ textAlign: "right" }}>
                          <label>Mode:</label>
                        </Col>
                        <Col md={9}>
                          <Select
                            options={paymentMode}
                            value={selectedPaymentMode}
                            onChange={setSelectedPaymentMode}
                            placeholder="Select Payment Mode"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                  </Col>
              </Row>
              <Row>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Currency:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={currencyOptions}
                              value={selectedCurrency}
                              onChange={setSelectedCurrency}
                              placeholder="Currency"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Amount:</label>
                              </Col>
                              <Col md={8}>
                              <CurrencyInput
                                id="total-amount"
                                name="totalAmount"
                                value={amount}
                                decimalsLimit={2}
                                onValueChange={(value) => setAmount(value)}
                                prefix="₦"
                                groupSeparator=","
                                placeholder="Amount"
                                className={`form-control ${classes.optioncss}`}
                                readOnly
                              />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Credit:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={bankOptions}
                              value={selectedBank}
                              onChange={setSelectedBank}
                              placeholder="Account"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Debit:</label>
                              </Col>
                              <Col md={8}>
                                <Select
                                  options={bankOptions2}
                                  value={selectedBank2}
                                  onChange={setSelectedBank2}
                                  placeholder="Account"
                                  isClearable
                                  classNamePrefix="react-select"
                                  required
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose2}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment2} disabled={addpaymenntLoad2} className={classes.btnss}>
              {addpaymenntLoad2 ? (
                <>
                  <Spinner size="sm" />
                  <span style={{ marginLeft: "5px" }}>
                    Processing, Please wait...
                  </span>
                </>
              ) : (
                "Save Payment"
              )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="xl">
  <div className={classes.modalContent}>

    <h3 className={classes.title}>Payment Details</h3>

    {viewPaymentData ? (
      <>
        {/* -------------------- TOP ROW -------------------- */}
        <div className={classes.topRow}>
          
          <div className={classes.Group}>
            <label>Payment Type</label>
            <input 
              type="text"
              value={viewPaymentData[0]?.mode?.name}
              disabled
              className="form-control"
            />
          </div>

          <div className={classes.Group}>
            <label>Journal Reference</label>
            <input 
              type="text"
              value={viewPaymentData[0]?.receipt_number}
              disabled
              className="form-control"
            />
          </div>

          <div className={classes.Group}>
            <label>Transaction Date</label>
            <input 
              type="date"
              value={viewPaymentData[0]?.transaction_date}
              disabled
              className="form-control"
            />
          </div>

          <div className={classes.Group}>
            <label>Bank</label>
            <input
              type="text"
              value={viewPaymentData[0]?.debit_account_data?.gl_name ?? ""}
              disabled
              className="form-control"
            />
          </div>

        </div>

        <h3 className={classes.titles}>Payment Breakdown</h3>

        {/* -------------------- TABLE -------------------- */}
        <table className={classes.table}>
          <thead style={{ backgroundColor: "#174384", color: "#fff" }}>
            <tr>
              <th>#</th>
              <th>Beneficiary</th>
              <th>Debit Account</th>
              <th>Beneficiary Account</th>
              <th>Amount Paid</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {viewPaymentData.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>

                <td>
                  <input
                    type="text"
                    value={item.particular}
                    disabled
                    className="form-control"
                     style={{ fontSize: 13 }}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    value={item?.credit_account?.gl_name || ""}
                    disabled
                    className="form-control"
                    style={{ textAlign: "left", fontSize: 13 }}
                  />
                </td>

                <td>
                  {/* account shown inside disabled input */}
                  <input
                    type="text"
                    value={`${item.supplier?.banks[0]?.bank_name} - ${item.supplier?.banks[0]?.bank_account}`}
                    disabled
                    className="form-control"
                     style={{ fontSize: 13 }}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    value={Number(item.amount).toLocaleString()}
                    disabled
                    className="form-control"
                     style={{ textAlign: "right", fontSize: 13 }}
                  />
                </td>
                <td>
 {item.transaction?.attached_document && (
          <span
            onClick={() => handleOpenDoc(item.transaction?.attached_document)}
            style={{
              cursor: "pointer",
              fontSize: "18px",
              color: "#174384"
            }}
            title="View Document"
          >
           <BsFillFileEarmarkPdfFill size={20} color="#0d0836ff"/> 
          </span>
        )}
         <button 
        onClick={() => handleTrashClick(item.id)}
        className={classes.removeBtn}
      >
        Remove
      </button>
                </td>
              </tr>
            ))}
            {extraRows.map((row, index) => (
  <tr key={`extra-${index}`}>

    {/* Serial Number */}
    <td>{viewPaymentData.length + index + 1}</td>

    {/* Beneficiary Select */}
    <td>
      <Select
        value={beneficiaryOptions.find(opt => opt.value === row.beneficiaryId)}
        onChange={(option) => handleExtraBeneficiaryChange(index, option)}
        options={beneficiaryOptions}
        placeholder="Select Beneficiary"
         menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base) => ({
            ...base,
            minHeight: "35px",
            fontSize: "12px",
            borderColor: "#ccc",
            "&:hover": { borderColor: "#999" },
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: "12px",
            color: "#999",
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: "12px",
          }),
      
          // 🔥 Added: reduce dropdown option font size
          option: (base, state) => ({
            ...base,
            fontSize: "13px",
            padding: "6px 10px",
          }),
          menu: (base) => ({
            ...base,
            fontSize: "13px",
          }),
        }}
      />
    </td>
 <td >
                   <Select
        value={expensesOptions.find(opt => opt.value === row.debitAccount) || null}
        onChange={(option) => handleExtraExpensesAccountChange(index, option)}
        options={expensesOptions}
        placeholder="Select Debit Account"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base) => ({
            ...base,
            minHeight: "35px",
            fontSize: "12px",
            // width: 300,
            borderColor: "#ccc",
            "&:hover": { borderColor: "#999" },
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: "12px",
            color: "#999",
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: "12px",
          }),
      
          // 🔥 Added: reduce dropdown option font size
          option: (base, state) => ({
            ...base,
            fontSize: "13px",
            padding: "6px 10px",
          }),
          menu: (base) => ({
            ...base,
            fontSize: "13px",
          }),
        }}
      />
     
                  </td>
    {/* Outstanding - empty because it's new */}
    {/* <td>
       <CurrencyInput
                      name={`outstanding-${index}`}
                      value={row.outstandingAmount}
                      disabled
                      className={`form-control ${classes.currencyInput}`}
                      style={{
                        textAlign: "right",
                        backgroundColor: "#f5f5f5",
                        cursor: "not-allowed",
                        border: "1px solid #ddd",
                        height: "35px",
                        fontSize: "12px",
                      }}
                      decimalsLimit={2}
                    />
    </td> */}

    {/* Account Select */}
    <td>
      <Select
        value={(row.accountOptions || []).find(a => a.value === row.accountId)}
        onChange={(selectedOption) =>
          handleExtraAccountChange(index, selectedOption)
        }
        options={row.accountOptions}
        placeholder="Select Account"
        menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({
                          ...base,
                          minHeight: "35px",
                          fontSize: "12px",
                          borderColor: "#ccc",
                          "&:hover": { borderColor: "#999" },
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "12px",
                          color: "#999",
                        }),
                        option: (base, state) => ({
            ...base,
            fontSize: "13px",
            padding: "6px 10px",
          }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: "12px",
                        }),
                      }}
      />
    </td>

    {/* Amount to Pay */}
    <td>
      <CurrencyInput
        value={row.amountToPay}
        onValueChange={(value) => handleExtraAmountChange(index, value)}
        className="form-control"
         style={{
                        textAlign: "right",
                        border: "1px solid #ccc",
                        height: "35px",
                        fontSize: "12px",
                        paddingRight: "10px",
                      }}
                      placeholder="0.00"
                      decimalsLimit={2}
                      allowNegativeValue={false}
      />
    </td>

    {/* Actions */}
    <td style={{display: "flex", alignItems: "center"}}>
      {row.documentUrl && (
        <span
          onClick={() => handleOpenDoc(row.documentUrl)}
          style={{ cursor: "pointer", marginRight: "10px" }}
        >
          <BsFillFileEarmarkPdfFill size={20} color="#174384" />
        </span>
      )}

      <button 
        onClick={() => removeExtraRow(index)}
        className={classes.removeBtn}
      >
        Remove
      </button>
    </td>

  </tr>
))}

          </tbody>
        </table>
         <div className={classes.actionRow}>

        <button 
  className={classes.addLineBtn}
  onClick={handleAddExtraLine}
>
  + Add Line
</button>
         </div>


        {/* -------------------- TOTAL -------------------- */}
        <div className={classes.totalRow}>
          <div className={classes.totalBox}>
            <span>Total Amount</span>
            <strong>
              {Number(grandTotal).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </strong>
          </div>
        </div>
        <div className={classes.footerButtons}>
          <button
                    type="submit"
                    className={classes.submitBtn}
                    // disabled={isSaving || !isBalanced}
                    onClick={handleFetchPaymentss}
                  >
                   
                    {isSaving ? (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <Spinner animation="border" size="sm" /> Updating...
                      </span>
                    ) : (
                      "Update Payments"
                    )}
                  </button>
        </div>

      </>
    ) : (
      <p>Loading...</p>
    )}

    <button className={classes.closeBtn} onClick={() => setShowViewModal(false)}>
      ×
    </button>
  </div>
</Modal>

<Modal show={showReferenceModal} onHide={() => setShowReferenceModal(false)} size="md">
  <div className={classes.modalContent}>

    <h3 className={classes.title}>Select Payment Reference</h3>

    <div className={classes.Group}>
      <label>Payment References</label>

      {loadingReferences ? (
        <div style={{ padding: "10px" }}>
          <Spinner animation="border" size="sm" />
        </div>
      ) : (
        <Select
  options={referenceOptions}
  onChange={handleSelectReference}
  placeholder="Select a processed payment"
  menuPortalTarget={document.body}
  styles={{
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    control: base => ({
      ...base,
      minHeight: "35px",
      fontSize: "12px",
    }),
  }}
/>

      )}
    </div>

    <button
      className={classes.closeBtn}
      onClick={() => setShowReferenceModal(false)}
    >
      ×
    </button>

  </div>
</Modal>

 <Modal show={show} onHide={handleClose} size="xl" animation={true}>
        <Modal.Header closeButton>
          <Modal.Title style={{fontSize: 16, fontWeight: 700}}>Add New Supplier/Contractor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Row>
                <Col>
                  <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </Col>

                <Col>
                  <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Phone Number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </Col>

                <Col>
                  <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Address</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group>
              <Container fluid style={{ marginTop: "40px" }} className={classes.wrapper}>
                <h6 className={classes.headerText} style={{ textAlign: "left" }}>Add Bank Accounts</h6>

                <div className="table-responsive">
                  <table className={classes.customtable}>
                    <thead>
                      <tr>
                        <th>Bank Name</th>
                        <th>Account Name</th>
                        <th>Account Number</th>
                        <th style={{ backgroundColor: "unset" }} className="text-center">
                          <button type="button" style={{ backgroundColor: "unset" }} className={classes.plusbtn} onClick={addRow}>
                            <FaPlus size={12} color="white" style={{ cursor: "pointer" }} />
                          </button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {rowses.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <Form.Control
                              type="text"
                              value={row.bankName}
                              onChange={(e) => handleChanges(index, "bankName", e.target.value)}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              value={row.accName}
                              onChange={(e) => handleChanges(index, "accName", e.target.value)}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              value={row.accNo}
                              onChange={(e) => handleChanges(index, "accNo", e.target.value)}
                            />
                          </td>
                          <td className="text-center">
                            <button type="button" style={{ backgroundColor: "unset" }} className={classes.btntrash} onClick={() => deleteRow(index)}>
                              <img src={DeleteIcon} alt="Delete" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Container>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ marginRight: "14px" }}>
          <Button variant="danger" onClick={handleClose}>
            Go back
          </Button>
          <Button className={classes.customButton} onClick={createBeneficiary}>
            {benLoading ? 'Processing....' : 'Create Beneficiary'}
          </Button>
        </Modal.Footer>
      </Modal>

<Modal show={showBeneficiaryAccModal} onHide={() => setShowBeneficiaryAccModal(false)} size="xl">
  <Modal.Header closeButton>
    <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>
      Update Beneficiary Account Details
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
   <Form.Group>
              <Container fluid style={{ marginTop: "40px" }} className={classes.wrapper}>
                

                <div className="table-responsive">
<table className={classes.customtable}>
                    <thead>
                      <tr>
                        <th>Bank Name</th>
                        <th>Account Name</th>
                        <th>Account Number</th>
                        <th style={{ backgroundColor: "unset" }} className="text-center">
                          <button type="button" style={{ backgroundColor: "unset" }} className={classes.plusbtn} onClick={addRow}>
                            <FaPlus size={12} color="white" style={{ cursor: "pointer" }} />
                          </button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {rowses.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <Form.Control
                              type="text"
                              value={row.bankName}
                              onChange={(e) => handleChanges(index, "bankName", e.target.value)}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              value={row.accName}
                              onChange={(e) => handleChanges(index, "accName", e.target.value)}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              value={row.accNo}
                              onChange={(e) => handleChanges(index, "accNo", e.target.value)}
                            />
                          </td>
                          <td className="text-center">
                            <button type="button" style={{ backgroundColor: "unset" }} className={classes.btntrash} onClick={() => deleteRow(index)}>
                              <img src={DeleteIcon} alt="Delete" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                   </Container>
                    </Form.Group>
    {/* <table className="table table-bordered">
      <thead>
        <tr>
          <th>Bank Name</th>
          <th>Account Name</th>
          <th>Account Number</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {beneficiaryAccounts[currentBeneficiaryId]?.map((acc, i) => (
          <tr key={i}>
            <td>{acc.bankName}</td>
            <td>{acc.accountName}</td>
            <td>{acc.accountNumber}</td>
            <td>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => removeBeneficiaryAccount(currentBeneficiaryId, i)}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table> */}
  </Modal.Body>

  <Modal.Footer style={{ marginRight: "14px" }}>
          <Button variant="danger" onClick={handleClose}>
            Go back
          </Button>
          <Button className={classes.customButton} onClick={createBeneficiaries}>
            {benLoading ? 'Processing....' : 'Update Beneficiary'}
          </Button>
        </Modal.Footer>
</Modal>

        <PaymentsUploadModal
            isOpen={openJournalModal}
            onClose={() => setOpenJournalModal(false)}
        />

      {/* <Footer /> */}
    </div>
  );
};

export default PaymentBulk;
